export interface PointDrawingConfig {
  ctx: CanvasRenderingContext2D;
  color: string;
  secondaryColor: string | undefined;
  scale: number;
  offsetX?: number;
  offsetY?: number;
}

export const IconSizeDefault = 50;

export const offsetForIcon = (iconName: string, size: number) => {
  let x = -size / 2;
  let y = -size / 2;

  switch (iconName) {
    case "PIN_ONE":
    case "RAIN_CLOUD":
      return { x: x, y: y * 2 };
    default:
      return { x: x, y: y };
  }
};

interface SVGIconsType {
  [key: string]: {
    draw: (config: PointDrawingConfig) => void;
  };
}
export var SVGIcons: SVGIconsType = {
  PIN_ONE: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = color;
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(16, 10.8476);
      ctx.bezierCurveTo(16, 5.96448, 20.1645, 2, 25.383, 2);
      ctx.bezierCurveTo(30.6015, 2, 34.766, 5.96448, 34.766, 10.8476);
      ctx.bezierCurveTo(34.766, 14.9571, 31.8097, 18.4139, 27.7737, 19.3809);
      ctx.lineTo(27.7737, 40.7745);
      ctx.bezierCurveTo(27.7737, 47.2531, 26.3855, 51, 25.383, 51);
      ctx.bezierCurveTo(24.3804, 51, 22.9665, 47.2289, 22.9665, 40.7745);
      ctx.lineTo(22.9665, 19.3809);
      ctx.bezierCurveTo(18.9306, 18.3897, 16, 14.9571, 16, 10.8476);
      ctx.closePath();
      ctx.moveTo(22.7095, 11.331);
      ctx.bezierCurveTo(24.4575, 11.331, 25.9228, 9.92896, 25.9228, 8.30932);
      ctx.bezierCurveTo(25.9228, 6.66552, 24.4575, 5.28762, 22.7095, 5.28762);
      ctx.bezierCurveTo(20.9871, 5.28762, 19.4961, 6.66552, 19.4961, 8.30932);
      ctx.bezierCurveTo(19.4961, 9.92896, 20.9871, 11.331, 22.7095, 11.331);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  MAN_WALKING: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor;
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = color;
      ctx.save();
      ctx.fillStyle = secondaryColor ?? "rgba(0,0,0,0)";
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(17, 13);
      ctx.lineTo(34, 13);
      ctx.bezierCurveTo(34, 13, 34, 13, 34, 13);
      ctx.lineTo(34, 47);
      ctx.bezierCurveTo(34, 47, 34, 47, 34, 47);
      ctx.lineTo(17, 47);
      ctx.bezierCurveTo(17, 47, 17, 47, 17, 47);
      ctx.lineTo(17, 13);
      ctx.bezierCurveTo(17, 13, 17, 13, 17, 13);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(7.33735, 47);
      ctx.bezierCurveTo(3.40964, 47, 1, 44.1754, 1, 40.6204);
      ctx.bezierCurveTo(1, 39.5246, 1.28916, 38.4045, 1.89157, 37.3331);
      ctx.lineTo(19.5542, 6.21417);
      ctx.bezierCurveTo(20.759, 4.09574, 22.8554, 3, 25, 3);
      ctx.bezierCurveTo(27.1205, 3, 29.2169, 4.09574, 30.4217, 6.21417);
      ctx.lineTo(48.0843, 37.3331);
      ctx.bezierCurveTo(48.6867, 38.3802, 49, 39.5246, 49, 40.6204);
      ctx.bezierCurveTo(49, 44.1754, 46.5663, 47, 42.6386, 47);
      ctx.lineTo(7.33735, 47);
      ctx.closePath();
      ctx.moveTo(25.3855, 18.5838);
      ctx.bezierCurveTo(26.8313, 18.5838, 27.9639, 17.3907, 27.9639, 16.0028);
      ctx.bezierCurveTo(27.9639, 14.5418, 26.8313, 13.373, 25.3855, 13.373);
      ctx.bezierCurveTo(23.9398, 13.373, 22.8072, 14.5418, 22.8072, 16.0028);
      ctx.bezierCurveTo(22.8072, 17.3907, 23.9398, 18.5838, 25.3855, 18.5838);
      ctx.closePath();
      ctx.moveTo(28.1325, 39.5977);
      ctx.bezierCurveTo(28.9036, 41.1561, 31.1928, 40.2064, 30.3494, 38.5019);
      ctx.lineTo(27.8434, 33.3641);
      ctx.bezierCurveTo(27.6747, 32.9745, 27.3855, 32.5606, 27.1687, 32.2441);
      ctx.lineTo(25.6024, 29.9552);
      ctx.lineTo(25.6747, 29.6386);
      ctx.bezierCurveTo(26.1566, 28.3481, 26.253, 27.5932, 26.3494, 26.2784);
      ctx.lineTo(26.6386, 22.7233);
      ctx.bezierCurveTo(26.759, 20.9945, 25.6988, 19.7039, 23.988, 19.7039);
      ctx.bezierCurveTo(22.6867, 19.7039, 21.8193, 20.3614, 20.6145, 21.5545);
      ctx.lineTo(18.759, 23.4051);
      ctx.bezierCurveTo(18.1325, 24.0138, 17.9398, 24.5252, 17.8675, 25.3287);
      ctx.lineTo(17.6747, 28.2994);
      ctx.bezierCurveTo(17.6024, 29.0055, 18.0361, 29.5169, 18.6867, 29.5412);
      ctx.bezierCurveTo(19.4096, 29.6143, 19.8193, 29.2003, 19.8916, 28.3968);
      ctx.lineTo(20.1566, 25.207);
      ctx.lineTo(21.0241, 24.4278);
      ctx.bezierCurveTo(21.3373, 24.1112, 21.7711, 24.3304, 21.747, 24.6469);
      ctx.lineTo(21.5542, 27.3254);
      ctx.bezierCurveTo(21.4337, 28.689, 21.7711, 29.3708, 22.6867, 30.5639);
      ctx.lineTo(25.1687, 33.6807);
      ctx.bezierCurveTo(25.4337, 33.9972, 25.4578, 34.1433, 25.5783, 34.3138);
      ctx.lineTo(28.1325, 39.5977);
      ctx.closePath();
      ctx.moveTo(32.4217, 24.5495);
      ctx.lineTo(29.6024, 24.5495);
      ctx.lineTo(27.8193, 22.5772);
      ctx.lineTo(27.6265, 25.5966);
      ctx.lineTo(28.3012, 26.2784);
      ctx.bezierCurveTo(28.6867, 26.668, 29.0482, 26.8141, 29.7711, 26.8141);
      ctx.lineTo(32.4217, 26.8141);
      ctx.bezierCurveTo(33.1446, 26.8141, 33.6506, 26.3758, 33.6506, 25.6696);
      ctx.bezierCurveTo(33.6506, 24.9878, 33.1446, 24.5495, 32.4217, 24.5495);
      ctx.closePath();
      ctx.moveTo(19.1928, 39.9386);
      ctx.lineTo(22.8795, 35.5069);
      ctx.bezierCurveTo(23.241, 35.093, 23.2892, 34.9712, 23.4096, 34.5329);
      ctx.lineTo(23.6747, 33.7294);
      ctx.lineTo(21.6988, 31.2214);
      ctx.lineTo(21.0964, 33.9729);
      ctx.lineTo(17.4819, 38.3315);
      ctx.bezierCurveTo(16.3012, 39.7438, 18.2048, 41.1317, 19.1928, 39.9386);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  RAIN_CLOUD: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor;
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = color;
      ctx.save();
      ctx.fillStyle = secondaryColor ?? "rgba(0,0,0,0)";
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(30.551, 29.5712);
      ctx.bezierCurveTo(28.7309, 30.4854, 26.6756, 31, 24.5, 31);
      ctx.bezierCurveTo(22.3975, 31, 20.4072, 30.5193, 18.6331, 29.6619);
      ctx.bezierCurveTo(17.1154, 30.5141, 15.3644, 31, 13.5, 31);
      ctx.bezierCurveTo(7.70101, 31, 3, 26.299, 3, 20.5);
      ctx.bezierCurveTo(3, 14.7773, 7.57812, 10.1239, 13.2717, 10.0024);
      ctx.bezierCurveTo(15.6933, 6.38311, 19.8183, 4, 24.5, 4);
      ctx.bezierCurveTo(31.1356, 4, 36.6531, 8.78746, 37.7867, 15.0968);
      ctx.bezierCurveTo(41.8706, 15.7169, 45, 19.243, 45, 23.5);
      ctx.bezierCurveTo(45, 28.1944, 41.1944, 32, 36.5, 32);
      ctx.bezierCurveTo(34.1839, 32, 32.0841, 31.0736, 30.551, 29.5712);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(29.2775, 48.7099);
      ctx.bezierCurveTo(28.665, 49.0363, 28.0423, 49.0873, 27.4094, 48.8629);
      ctx.bezierCurveTo(26.7765, 48.6385, 26.2967, 48.2204, 25.97, 47.6084);
      ctx.lineTo(22.295, 40.2652);
      ctx.bezierCurveTo(21.9683, 39.6533, 21.9173, 39.0312, 22.1419, 38.3988);
      ctx.bezierCurveTo(22.3665, 37.7665, 22.785, 37.2871, 23.3975, 36.9608);
      ctx.bezierCurveTo(24.01, 36.6344, 24.6327, 36.5834, 25.2656, 36.8078);
      ctx.bezierCurveTo(25.8985, 37.0322, 26.3783, 37.4503, 26.705, 38.0623);
      ctx.lineTo(30.38, 45.4055);
      ctx.bezierCurveTo(30.7067, 46.0174, 30.7577, 46.6395, 30.5331, 47.2719);
      ctx.bezierCurveTo(30.3085, 47.9042, 29.89, 48.3835, 29.2775, 48.7099);
      ctx.closePath();
      ctx.moveTo(43.9775, 48.7099);
      ctx.bezierCurveTo(43.365, 49.0363, 42.7423, 49.0873, 42.1094, 48.8629);
      ctx.bezierCurveTo(41.4765, 48.6385, 40.9967, 48.2204, 40.67, 47.6084);
      ctx.lineTo(36.995, 40.2652);
      ctx.bezierCurveTo(36.6683, 39.6533, 36.6173, 39.0312, 36.8419, 38.3988);
      ctx.bezierCurveTo(37.0665, 37.7665, 37.485, 37.2871, 38.0975, 36.9608);
      ctx.bezierCurveTo(38.71, 36.6344, 39.3327, 36.5834, 39.9656, 36.8078);
      ctx.bezierCurveTo(40.5985, 37.0322, 41.0783, 37.4503, 41.405, 38.0623);
      ctx.lineTo(45.08, 45.4055);
      ctx.bezierCurveTo(45.4067, 46.0174, 45.4577, 46.6395, 45.2331, 47.2719);
      ctx.bezierCurveTo(45.0085, 47.9042, 44.59, 48.3835, 43.9775, 48.7099);
      ctx.closePath();
      ctx.moveTo(14.5775, 48.7099);
      ctx.bezierCurveTo(13.965, 49.0363, 13.3423, 49.0873, 12.7094, 48.8629);
      ctx.bezierCurveTo(12.0765, 48.6385, 11.5967, 48.2204, 11.27, 47.6084);
      ctx.lineTo(7.595, 40.2652);
      ctx.bezierCurveTo(7.26833, 39.6533, 7.21729, 39.0312, 7.44188, 38.3988);
      ctx.bezierCurveTo(7.66646, 37.7665, 8.085, 37.2871, 8.6975, 36.9608);
      ctx.bezierCurveTo(9.31, 36.6344, 9.93271, 36.5834, 10.5656, 36.8078);
      ctx.bezierCurveTo(11.1985, 37.0322, 11.6783, 37.4503, 12.005, 38.0623);
      ctx.lineTo(15.68, 45.4055);
      ctx.bezierCurveTo(16.0067, 46.0174, 16.0577, 46.6395, 15.8331, 47.2719);
      ctx.bezierCurveTo(15.6085, 47.9042, 15.19, 48.3835, 14.5775, 48.7099);
      ctx.closePath();
      ctx.moveTo(13.475, 34.2683);
      ctx.bezierCurveTo(9.75917, 34.2683, 6.58438, 32.9526, 3.95063, 30.3213);
      ctx.bezierCurveTo(1.31688, 27.69, 0, 24.5181, 0, 20.8057);
      ctx.bezierCurveTo(0, 17.4197, 1.12292, 14.462, 3.36875, 11.9327);
      ctx.bezierCurveTo(5.61458, 9.40338, 8.39125, 7.91434, 11.6988, 7.46559);
      ctx.bezierCurveTo(13.0054, 5.14024, 14.7919, 3.31464, 17.0581, 1.98878);
      ctx.bezierCurveTo(19.3244, 0.662928, 21.805, 0, 24.5, 0);
      ctx.bezierCurveTo(28.175, 0, 31.3702, 1.17287, 34.0856, 3.51862);
      ctx.bezierCurveTo(36.801, 5.86436, 38.4446, 8.79144, 39.0163, 12.2999);
      ctx.bezierCurveTo(41.8338, 12.5446, 44.2021, 13.7073, 46.1213, 15.7879);
      ctx.bezierCurveTo(48.0404, 17.8685, 49, 20.357, 49, 23.2535);
      ctx.bezierCurveTo(49, 26.3131, 47.9281, 28.9139, 45.7844, 31.0556);
      ctx.bezierCurveTo(43.6406, 33.1974, 41.0375, 34.2683, 37.975, 34.2683);
      ctx.lineTo(13.475, 34.2683);
      ctx.closePath();
      ctx.moveTo(13.475, 29.3728);
      ctx.lineTo(37.975, 29.3728);
      ctx.bezierCurveTo(39.69, 29.3728, 41.1396, 28.7813, 42.3238, 27.5982);
      ctx.bezierCurveTo(43.5079, 26.4151, 44.1, 24.9669, 44.1, 23.2535);
      ctx.bezierCurveTo(44.1, 21.5401, 43.5079, 20.0918, 42.3238, 18.9087);
      ctx.bezierCurveTo(41.1396, 17.7257, 39.69, 17.1341, 37.975, 17.1341);
      ctx.lineTo(34.3, 17.1341);
      ctx.lineTo(34.3, 14.6864);
      ctx.bezierCurveTo(34.3, 11.9939, 33.3404, 9.68895, 31.4213, 7.77155);
      ctx.bezierCurveTo(29.5021, 5.85416, 27.195, 4.89547, 24.5, 4.89547);
      ctx.bezierCurveTo(22.54, 4.89547, 20.7535, 5.42581, 19.1406, 6.48649);
      ctx.bezierCurveTo(17.5277, 7.54718, 16.3129, 8.97502, 15.4963, 10.77);
      ctx.lineTo(14.8838, 12.2387);
      ctx.lineTo(13.3525, 12.2387);
      ctx.bezierCurveTo(11.025, 12.3203, 9.03438, 13.1872, 7.38063, 14.8394);
      ctx.bezierCurveTo(5.72688, 16.4916, 4.9, 18.4804, 4.9, 20.8057);
      ctx.bezierCurveTo(4.9, 23.1719, 5.73708, 25.1913, 7.41125, 26.8639);
      ctx.bezierCurveTo(9.08542, 28.5365, 11.1067, 29.3728, 13.475, 29.3728);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  THUNDER_CLOUD: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = secondaryColor;
      ctx.save();
      ctx.font = "10px sans-serif";

      ctx.beginPath();
      ctx.moveTo(28.551, 28.5712);
      ctx.bezierCurveTo(26.7309, 29.4854, 24.6756, 30, 22.5, 30);
      ctx.bezierCurveTo(20.3975, 30, 18.4072, 29.5193, 16.6331, 28.6619);
      ctx.bezierCurveTo(15.1154, 29.5141, 13.3644, 30, 11.5, 30);
      ctx.bezierCurveTo(5.70101, 30, 1, 25.299, 1, 19.5);
      ctx.bezierCurveTo(1, 13.7773, 5.57812, 9.12389, 11.2717, 9.00244);
      ctx.bezierCurveTo(13.6933, 5.38311, 17.8183, 3, 22.5, 3);
      ctx.bezierCurveTo(29.1356, 3, 34.6531, 7.78746, 35.7867, 14.0968);
      ctx.bezierCurveTo(39.8706, 14.7169, 43, 18.243, 43, 22.5);
      ctx.bezierCurveTo(43, 27.1944, 39.1944, 31, 34.5, 31);
      ctx.bezierCurveTo(32.1839, 31, 30.0841, 30.0736, 28.551, 28.5712);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(21.4875, 49);
      ctx.lineTo(26.775, 43.042);
      ctx.lineTo(22.275, 40.8148);
      ctx.lineTo(28.8, 33.4091);
      ctx.lineTo(34.7625, 33.4091);
      ctx.lineTo(29.475, 39.367);
      ctx.lineTo(33.975, 41.5943);
      ctx.lineTo(27.45, 49);
      ctx.lineTo(21.4875, 49);
      ctx.closePath();
      ctx.moveTo(7.9875, 49);
      ctx.lineTo(13.275, 43.042);
      ctx.lineTo(8.775, 40.8148);
      ctx.lineTo(15.3, 33.4091);
      ctx.lineTo(21.2625, 33.4091);
      ctx.lineTo(15.975, 39.367);
      ctx.lineTo(20.475, 41.5943);
      ctx.lineTo(13.95, 49);
      ctx.lineTo(7.9875, 49);
      ctx.closePath();
      ctx.moveTo(12.375, 31.1818);
      ctx.bezierCurveTo(8.9625, 31.1818, 6.04687, 29.9847, 3.62812, 27.5903);
      ctx.bezierCurveTo(1.20937, 25.196, 0, 22.3098, 0, 18.9318);
      ctx.bezierCurveTo(0, 15.8508, 1.03125, 13.1595, 3.09375, 10.858);
      ctx.bezierCurveTo(5.15625, 8.55644, 7.70625, 7.20152, 10.7437, 6.79318);
      ctx.bezierCurveTo(11.9437, 4.67727, 13.5844, 3.0161, 15.6656, 1.80966);
      ctx.bezierCurveTo(17.7469, 0.60322, 20.025, 0, 22.5, 0);
      ctx.bezierCurveTo(25.875, 0, 28.8094, 1.06723, 31.3031, 3.2017);
      ctx.bezierCurveTo(33.7969, 5.33617, 35.3062, 7.99962, 35.8312, 11.192);
      ctx.bezierCurveTo(38.4187, 11.4148, 40.5937, 12.4727, 42.3562, 14.3659);
      ctx.bezierCurveTo(44.1187, 16.2591, 45, 18.5235, 45, 21.1591);
      ctx.bezierCurveTo(45, 23.9432, 44.0156, 26.3097, 42.0469, 28.2585);
      ctx.bezierCurveTo(40.0781, 30.2074, 37.6875, 31.1818, 34.875, 31.1818);
      ctx.lineTo(12.375, 31.1818);
      ctx.closePath();
      ctx.moveTo(12.375, 26.7273);
      ctx.lineTo(34.875, 26.7273);
      ctx.bezierCurveTo(36.45, 26.7273, 37.7812, 26.189, 38.8687, 25.1125);
      ctx.bezierCurveTo(39.9562, 24.036, 40.5, 22.7182, 40.5, 21.1591);
      ctx.bezierCurveTo(40.5, 19.6, 39.9562, 18.2822, 38.8687, 17.2057);
      ctx.bezierCurveTo(37.7812, 16.1292, 36.45, 15.5909, 34.875, 15.5909);
      ctx.lineTo(31.5, 15.5909);
      ctx.lineTo(31.5, 13.3636);
      ctx.bezierCurveTo(31.5, 10.9136, 30.6187, 8.81629, 28.8562, 7.07159);
      ctx.bezierCurveTo(27.0937, 5.32689, 24.975, 4.45455, 22.5, 4.45455);
      ctx.bezierCurveTo(20.7, 4.45455, 19.0594, 4.93712, 17.5781, 5.90227);
      ctx.bezierCurveTo(16.0969, 6.86742, 14.9812, 8.16667, 14.2312, 9.8);
      ctx.lineTo(13.6687, 11.1364);
      ctx.lineTo(12.2625, 11.1364);
      ctx.bezierCurveTo(10.125, 11.2106, 8.29687, 11.9994, 6.77812, 13.5028);
      ctx.bezierCurveTo(5.25937, 15.0062, 4.5, 16.8159, 4.5, 18.9318);
      ctx.bezierCurveTo(4.5, 21.0848, 5.26875, 22.9223, 6.80625, 24.4443);
      ctx.bezierCurveTo(8.34375, 25.9663, 10.2, 26.7273, 12.375, 26.7273);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },

  SUN: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = secondaryColor;
      ctx.save();
      ctx.font = "10px sans-serif";

      ctx.beginPath();
      ctx.arc(24.5, 24.5, 10.5, 0, 6.283185307179586, false);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(22.2727, 8.90909);
      ctx.lineTo(22.2727, 0);
      ctx.lineTo(26.7273, 0);
      ctx.lineTo(26.7273, 8.90909);
      ctx.lineTo(22.2727, 8.90909);
      ctx.closePath();
      ctx.moveTo(37.0841, 15.0341);
      ctx.lineTo(34.0216, 11.9716);
      ctx.lineTo(40.258, 5.56818);
      ctx.lineTo(43.3761, 8.74205);
      ctx.lineTo(37.0841, 15.0341);
      ctx.closePath();
      ctx.moveTo(40.0909, 26.7273);
      ctx.lineTo(40.0909, 22.2727);
      ctx.lineTo(49, 22.2727);
      ctx.lineTo(49, 26.7273);
      ctx.lineTo(40.0909, 26.7273);
      ctx.closePath();
      ctx.moveTo(22.2727, 49);
      ctx.lineTo(22.2727, 40.0909);
      ctx.lineTo(26.7273, 40.0909);
      ctx.lineTo(26.7273, 49);
      ctx.lineTo(22.2727, 49);
      ctx.closePath();
      ctx.moveTo(11.9159, 14.9227);
      ctx.lineTo(5.56818, 8.74205);
      ctx.lineTo(8.74205, 5.62386);
      ctx.lineTo(15.0341, 11.9159);
      ctx.lineTo(11.9159, 14.9227);
      ctx.closePath();
      ctx.moveTo(40.2023, 43.4318);
      ctx.lineTo(34.0216, 37.0284);
      ctx.lineTo(37.0284, 34.0216);
      ctx.lineTo(43.3761, 40.1466);
      ctx.lineTo(40.2023, 43.4318);
      ctx.closePath();
      ctx.moveTo(0, 26.7273);
      ctx.lineTo(0, 22.2727);
      ctx.lineTo(8.90909, 22.2727);
      ctx.lineTo(8.90909, 26.7273);
      ctx.lineTo(0, 26.7273);
      ctx.closePath();
      ctx.moveTo(8.74205, 43.4318);
      ctx.lineTo(5.62386, 40.258);
      ctx.lineTo(11.8602, 34.0216);
      ctx.lineTo(13.475, 35.525);
      ctx.lineTo(15.0898, 37.0841);
      ctx.lineTo(8.74205, 43.4318);
      ctx.closePath();
      ctx.moveTo(24.5, 37.8636);
      ctx.bezierCurveTo(20.7879, 37.8636, 17.6326, 36.5644, 15.0341, 33.9659);
      ctx.bezierCurveTo(12.4356, 31.3674, 11.1364, 28.2121, 11.1364, 24.5);
      ctx.bezierCurveTo(11.1364, 20.7879, 12.4356, 17.6326, 15.0341, 15.0341);
      ctx.bezierCurveTo(17.6326, 12.4356, 20.7879, 11.1364, 24.5, 11.1364);
      ctx.bezierCurveTo(28.2121, 11.1364, 31.3674, 12.4356, 33.9659, 15.0341);
      ctx.bezierCurveTo(36.5644, 17.6326, 37.8636, 20.7879, 37.8636, 24.5);
      ctx.bezierCurveTo(37.8636, 28.2121, 36.5644, 31.3674, 33.9659, 33.9659);
      ctx.bezierCurveTo(31.3674, 36.5644, 28.2121, 37.8636, 24.5, 37.8636);
      ctx.closePath();
      ctx.moveTo(24.5, 33.4091);
      ctx.bezierCurveTo(26.95, 33.4091, 29.0473, 32.5367, 30.792, 30.792);
      ctx.bezierCurveTo(32.5367, 29.0473, 33.4091, 26.95, 33.4091, 24.5);
      ctx.bezierCurveTo(33.4091, 22.05, 32.5367, 19.9527, 30.792, 18.208);
      ctx.bezierCurveTo(29.0473, 16.4633, 26.95, 15.5909, 24.5, 15.5909);
      ctx.bezierCurveTo(22.05, 15.5909, 19.9527, 16.4633, 18.208, 18.208);
      ctx.bezierCurveTo(16.4633, 19.9527, 15.5909, 22.05, 15.5909, 24.5);
      ctx.bezierCurveTo(15.5909, 26.95, 16.4633, 29.0473, 18.208, 30.792);
      ctx.bezierCurveTo(19.9527, 32.5367, 22.05, 33.4091, 24.5, 33.4091);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  FACE_1: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = color;
      ctx.save();
      ctx.font = "10px sans-serif";
      ctx.fillStyle = secondaryColor;
      ctx.beginPath();
      ctx.arc(25, 25, 22, 0, 6.283185307179586, false);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(15.4329, 1.90301);
      ctx.bezierCurveTo(18.4661, 0.646644, 21.717, 0, 25, 0);
      ctx.bezierCurveTo(28.283, 0, 31.5339, 0.646644, 34.5671, 1.90301);
      ctx.bezierCurveTo(37.6002, 3.15938, 40.3562, 5.00087, 42.6777, 7.32233);
      ctx.bezierCurveTo(44.9991, 9.64379, 46.8406, 12.3998, 48.097, 15.4329);
      ctx.bezierCurveTo(49.3534, 18.4661, 50, 21.717, 50, 25);
      ctx.bezierCurveTo(50, 28.283, 49.3534, 31.5339, 48.097, 34.5671);
      ctx.bezierCurveTo(46.8406, 37.6002, 44.9991, 40.3562, 42.6777, 42.6777);
      ctx.bezierCurveTo(40.3562, 44.9991, 37.6002, 46.8406, 34.5671, 48.097);
      ctx.bezierCurveTo(31.5339, 49.3534, 28.283, 50, 25, 50);
      ctx.bezierCurveTo(21.717, 50, 18.4661, 49.3534, 15.4329, 48.097);
      ctx.bezierCurveTo(12.3998, 46.8406, 9.64379, 44.9991, 7.32233, 42.6777);
      ctx.bezierCurveTo(5.00087, 40.3562, 3.15938, 37.6002, 1.90301, 34.5671);
      ctx.bezierCurveTo(0.646644, 31.5339, 0, 28.283, 0, 25);
      ctx.bezierCurveTo(0, 21.717, 0.646644, 18.4661, 1.90301, 15.4329);
      ctx.bezierCurveTo(3.15938, 12.3998, 5.00087, 9.6438, 7.32233, 7.32233);
      ctx.bezierCurveTo(9.6438, 5.00087, 12.3998, 3.15938, 15.4329, 1.90301);
      ctx.closePath();
      ctx.moveTo(25, 5);
      ctx.bezierCurveTo(22.3736, 5, 19.7728, 5.51732, 17.3463, 6.52241);
      ctx.bezierCurveTo(14.9198, 7.5275, 12.715, 9.00069, 10.8579, 10.8579);
      ctx.bezierCurveTo(9.00069, 12.715, 7.5275, 14.9198, 6.52241, 17.3463);
      ctx.bezierCurveTo(5.51731, 19.7728, 5, 22.3736, 5, 25);
      ctx.bezierCurveTo(5, 27.6264, 5.51731, 30.2272, 6.52241, 32.6537);
      ctx.bezierCurveTo(7.5275, 35.0802, 9.00069, 37.285, 10.8579, 39.1421);
      ctx.bezierCurveTo(12.715, 40.9993, 14.9198, 42.4725, 17.3463, 43.4776);
      ctx.bezierCurveTo(19.7728, 44.4827, 22.3736, 45, 25, 45);
      ctx.bezierCurveTo(27.6264, 45, 30.2272, 44.4827, 32.6537, 43.4776);
      ctx.bezierCurveTo(35.0802, 42.4725, 37.285, 40.9993, 39.1421, 39.1421);
      ctx.bezierCurveTo(40.9993, 37.285, 42.4725, 35.0802, 43.4776, 32.6537);
      ctx.bezierCurveTo(44.4827, 30.2272, 45, 27.6264, 45, 25);
      ctx.bezierCurveTo(45, 22.3736, 44.4827, 19.7728, 43.4776, 17.3463);
      ctx.bezierCurveTo(42.4725, 14.9198, 40.9993, 12.715, 39.1421, 10.8579);
      ctx.bezierCurveTo(37.285, 9.00069, 35.0802, 7.5275, 32.6537, 6.52241);
      ctx.bezierCurveTo(30.2272, 5.51732, 27.6264, 5, 25, 5);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(15, 17.5);
      ctx.bezierCurveTo(15, 16.1193, 16.1193, 15, 17.5, 15);
      ctx.lineTo(17.525, 15);
      ctx.bezierCurveTo(18.9057, 15, 20.025, 16.1193, 20.025, 17.5);
      ctx.bezierCurveTo(20.025, 18.8807, 18.9057, 20, 17.525, 20);
      ctx.lineTo(17.5, 20);
      ctx.bezierCurveTo(16.1193, 20, 15, 18.8807, 15, 17.5);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(30, 17.5);
      ctx.bezierCurveTo(30, 16.1193, 31.1193, 15, 32.5, 15);
      ctx.lineTo(32.525, 15);
      ctx.bezierCurveTo(33.9057, 15, 35.025, 16.1193, 35.025, 17.5);
      ctx.bezierCurveTo(35.025, 18.8807, 33.9057, 20, 32.525, 20);
      ctx.lineTo(32.5, 20);
      ctx.bezierCurveTo(31.1193, 20, 30, 18.8807, 30, 17.5);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(13.2322, 25.7322);
      ctx.bezierCurveTo(13.7011, 25.2634, 14.337, 25, 15, 25);
      ctx.lineTo(35, 25);
      ctx.bezierCurveTo(35.663, 25, 36.2989, 25.2634, 36.7678, 25.7322);
      ctx.bezierCurveTo(37.2366, 26.2011, 37.5, 26.837, 37.5, 27.5);
      ctx.bezierCurveTo(37.5, 30.8152, 36.183, 33.9946, 33.8388, 36.3388);
      ctx.bezierCurveTo(31.4946, 38.683, 28.3152, 40, 25, 40);
      ctx.bezierCurveTo(21.6848, 40, 18.5054, 38.683, 16.1612, 36.3388);
      ctx.bezierCurveTo(13.817, 33.9946, 12.5, 30.8152, 12.5, 27.5);
      ctx.bezierCurveTo(12.5, 26.837, 12.7634, 26.2011, 13.2322, 25.7322);
      ctx.closePath();
      ctx.moveTo(17.9289, 30);
      ctx.bezierCurveTo(18.2983, 31.0448, 18.8982, 32.0048, 19.6967, 32.8033);
      ctx.bezierCurveTo(21.1032, 34.2098, 23.0109, 35, 25, 35);
      ctx.bezierCurveTo(26.9891, 35, 28.8968, 34.2098, 30.3033, 32.8033);
      ctx.bezierCurveTo(31.1018, 32.0048, 31.7017, 31.0448, 32.0711, 30);
      ctx.lineTo(17.9289, 30);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  FACE_2: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = color;
      ctx.save();
      ctx.font = "10px sans-serif";
      ctx.fillStyle = secondaryColor;
      ctx.beginPath();
      ctx.arc(25, 25, 22, 0, 6.283185307179586, false);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(15.1243, 1.86495);
      ctx.bezierCurveTo(18.0967, 0.633711, 21.2826, 0, 24.5, 0);
      ctx.bezierCurveTo(27.7174, 0, 30.9033, 0.633711, 33.8757, 1.86495);
      ctx.bezierCurveTo(36.8482, 3.09619, 39.5491, 4.90085, 41.8241, 7.17588);
      ctx.bezierCurveTo(44.0991, 9.45092, 45.9038, 12.1518, 47.1351, 15.1243);
      ctx.bezierCurveTo(48.3663, 18.0967, 49, 21.2826, 49, 24.5);
      ctx.bezierCurveTo(49, 27.7174, 48.3663, 30.9033, 47.1351, 33.8757);
      ctx.bezierCurveTo(45.9038, 36.8482, 44.0991, 39.5491, 41.8241, 41.8241);
      ctx.bezierCurveTo(39.5491, 44.0991, 36.8482, 45.9038, 33.8757, 47.1351);
      ctx.bezierCurveTo(30.9033, 48.3663, 27.7174, 49, 24.5, 49);
      ctx.bezierCurveTo(21.2826, 49, 18.0967, 48.3663, 15.1243, 47.1351);
      ctx.bezierCurveTo(12.1518, 45.9038, 9.45092, 44.0991, 7.17588, 41.8241);
      ctx.bezierCurveTo(4.90085, 39.5491, 3.09619, 36.8482, 1.86495, 33.8757);
      ctx.bezierCurveTo(0.633711, 30.9033, 0, 27.7174, 0, 24.5);
      ctx.bezierCurveTo(0, 21.2826, 0.633711, 18.0967, 1.86495, 15.1243);
      ctx.bezierCurveTo(3.09619, 12.1518, 4.90085, 9.45092, 7.17588, 7.17588);
      ctx.bezierCurveTo(9.45092, 4.90085, 12.1518, 3.09619, 15.1243, 1.86495);
      ctx.closePath();
      ctx.moveTo(24.5, 4.9);
      ctx.bezierCurveTo(21.9261, 4.9, 19.3774, 5.40697, 16.9994, 6.39196);
      ctx.bezierCurveTo(14.6214, 7.37695, 12.4607, 8.82068, 10.6407, 10.6407);
      ctx.bezierCurveTo(8.82068, 12.4607, 7.37695, 14.6214, 6.39196, 16.9994);
      ctx.bezierCurveTo(5.40697, 19.3774, 4.9, 21.9261, 4.9, 24.5);
      ctx.bezierCurveTo(4.9, 27.0739, 5.40697, 29.6226, 6.39196, 32.0006);
      ctx.bezierCurveTo(7.37695, 34.3786, 8.82068, 36.5393, 10.6407, 38.3593);
      ctx.bezierCurveTo(12.4607, 40.1793, 14.6214, 41.623, 16.9994, 42.608);
      ctx.bezierCurveTo(19.3774, 43.593, 21.9261, 44.1, 24.5, 44.1);
      ctx.bezierCurveTo(27.0739, 44.1, 29.6226, 43.593, 32.0006, 42.608);
      ctx.bezierCurveTo(34.3786, 41.623, 36.5393, 40.1793, 38.3593, 38.3593);
      ctx.bezierCurveTo(40.1793, 36.5393, 41.6231, 34.3786, 42.608, 32.0006);
      ctx.bezierCurveTo(43.593, 29.6226, 44.1, 27.0739, 44.1, 24.5);
      ctx.bezierCurveTo(44.1, 21.9261, 43.593, 19.3774, 42.608, 16.9994);
      ctx.bezierCurveTo(41.623, 14.6214, 40.1793, 12.4607, 38.3593, 10.6407);
      ctx.bezierCurveTo(36.5393, 8.82068, 34.3786, 7.37695, 32.0006, 6.39196);
      ctx.bezierCurveTo(29.6226, 5.40697, 27.0739, 4.9, 24.5, 4.9);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(14.7, 19.6);
      ctx.bezierCurveTo(14.7, 18.2469, 15.7969, 17.15, 17.15, 17.15);
      ctx.lineTo(17.1745, 17.15);
      ctx.bezierCurveTo(18.5276, 17.15, 19.6245, 18.2469, 19.6245, 19.6);
      ctx.bezierCurveTo(19.6245, 20.9531, 18.5276, 22.05, 17.1745, 22.05);
      ctx.lineTo(17.15, 22.05);
      ctx.bezierCurveTo(15.7969, 22.05, 14.7, 20.9531, 14.7, 19.6);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(29.4, 19.6);
      ctx.bezierCurveTo(29.4, 18.2469, 30.4969, 17.15, 31.85, 17.15);
      ctx.lineTo(31.8745, 17.15);
      ctx.bezierCurveTo(33.2276, 17.15, 34.3245, 18.2469, 34.3245, 19.6);
      ctx.bezierCurveTo(34.3245, 20.9531, 33.2276, 22.05, 31.8745, 22.05);
      ctx.lineTo(31.85, 22.05);
      ctx.bezierCurveTo(30.4969, 22.05, 29.4, 20.9531, 29.4, 19.6);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(16.6604, 30.1);
      ctx.bezierCurveTo(17.6269, 29.153, 19.178, 29.1689, 20.125, 30.1354);
      ctx.bezierCurveTo(20.6953, 30.7174, 21.376, 31.1798, 22.1272, 31.4955);
      ctx.bezierCurveTo(22.8785, 31.8112, 23.6851, 31.9738, 24.5, 31.9738);
      ctx.bezierCurveTo(25.3149, 31.9738, 26.1215, 31.8112, 26.8728, 31.4955);
      ctx.bezierCurveTo(27.624, 31.1798, 28.3047, 30.7174, 28.875, 30.1354);
      ctx.bezierCurveTo(29.822, 29.1689, 31.3731, 29.153, 32.3396, 30.1);
      ctx.bezierCurveTo(33.3061, 31.047, 33.322, 32.5981, 32.375, 33.5646);
      ctx.bezierCurveTo(31.3485, 34.6123, 30.1232, 35.4447, 28.771, 36.0129);
      ctx.bezierCurveTo(27.4188, 36.5811, 25.9668, 36.8738, 24.5, 36.8738);
      ctx.bezierCurveTo(23.0332, 36.8738, 21.5812, 36.5811, 20.229, 36.0129);
      ctx.bezierCurveTo(18.8768, 35.4447, 17.6515, 34.6123, 16.625, 33.5646);
      ctx.bezierCurveTo(15.678, 32.5981, 15.6939, 31.047, 16.6604, 30.1);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  FACE_3: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = secondaryColor;
      ctx.save();

      ctx.beginPath();
      ctx.arc(25, 25, 22, 0, 6.283185307179586, false);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(15.4329, 1.90301);
      ctx.bezierCurveTo(18.4661, 0.646644, 21.717, 0, 25, 0);
      ctx.bezierCurveTo(28.283, 0, 31.5339, 0.646644, 34.5671, 1.90301);
      ctx.bezierCurveTo(37.6002, 3.15938, 40.3562, 5.00087, 42.6777, 7.32233);
      ctx.bezierCurveTo(44.9991, 9.64379, 46.8406, 12.3998, 48.097, 15.4329);
      ctx.bezierCurveTo(49.3534, 18.4661, 50, 21.717, 50, 25);
      ctx.bezierCurveTo(50, 28.283, 49.3534, 31.5339, 48.097, 34.5671);
      ctx.bezierCurveTo(46.8406, 37.6002, 44.9991, 40.3562, 42.6777, 42.6777);
      ctx.bezierCurveTo(40.3562, 44.9991, 37.6002, 46.8406, 34.5671, 48.097);
      ctx.bezierCurveTo(31.5339, 49.3534, 28.283, 50, 25, 50);
      ctx.bezierCurveTo(21.717, 50, 18.4661, 49.3534, 15.4329, 48.097);
      ctx.bezierCurveTo(12.3998, 46.8406, 9.64379, 44.9991, 7.32233, 42.6777);
      ctx.bezierCurveTo(5.00087, 40.3562, 3.15938, 37.6002, 1.90301, 34.5671);
      ctx.bezierCurveTo(0.646644, 31.5339, 0, 28.283, 0, 25);
      ctx.bezierCurveTo(0, 21.717, 0.646644, 18.4661, 1.90301, 15.4329);
      ctx.bezierCurveTo(3.15938, 12.3998, 5.00087, 9.6438, 7.32233, 7.32233);
      ctx.bezierCurveTo(9.6438, 5.00087, 12.3998, 3.15938, 15.4329, 1.90301);
      ctx.closePath();
      ctx.moveTo(25, 5);
      ctx.bezierCurveTo(22.3736, 5, 19.7728, 5.51732, 17.3463, 6.52241);
      ctx.bezierCurveTo(14.9198, 7.5275, 12.715, 9.00069, 10.8579, 10.8579);
      ctx.bezierCurveTo(9.00069, 12.715, 7.5275, 14.9198, 6.52241, 17.3463);
      ctx.bezierCurveTo(5.51731, 19.7728, 5, 22.3736, 5, 25);
      ctx.bezierCurveTo(5, 27.6264, 5.51731, 30.2272, 6.52241, 32.6537);
      ctx.bezierCurveTo(7.5275, 35.0802, 9.00069, 37.285, 10.8579, 39.1421);
      ctx.bezierCurveTo(12.715, 40.9993, 14.9198, 42.4725, 17.3463, 43.4776);
      ctx.bezierCurveTo(19.7728, 44.4827, 22.3736, 45, 25, 45);
      ctx.bezierCurveTo(27.6264, 45, 30.2272, 44.4827, 32.6537, 43.4776);
      ctx.bezierCurveTo(35.0802, 42.4725, 37.285, 40.9993, 39.1421, 39.1421);
      ctx.bezierCurveTo(40.9993, 37.285, 42.4725, 35.0802, 43.4776, 32.6537);
      ctx.bezierCurveTo(44.4827, 30.2272, 45, 27.6264, 45, 25);
      ctx.bezierCurveTo(45, 22.3736, 44.4827, 19.7728, 43.4776, 17.3463);
      ctx.bezierCurveTo(42.4725, 14.9198, 40.9993, 12.715, 39.1421, 10.8579);
      ctx.bezierCurveTo(37.285, 9.00069, 35.0802, 7.5275, 32.6537, 6.52241);
      ctx.bezierCurveTo(30.2272, 5.51732, 27.6264, 5, 25, 5);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(15, 20);
      ctx.bezierCurveTo(15, 18.6193, 16.1193, 17.5, 17.5, 17.5);
      ctx.lineTo(17.525, 17.5);
      ctx.bezierCurveTo(18.9057, 17.5, 20.025, 18.6193, 20.025, 20);
      ctx.bezierCurveTo(20.025, 21.3807, 18.9057, 22.5, 17.525, 22.5);
      ctx.lineTo(17.5, 22.5);
      ctx.bezierCurveTo(16.1193, 22.5, 15, 21.3807, 15, 20);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(30, 20);
      ctx.bezierCurveTo(30, 18.6193, 31.1193, 17.5, 32.5, 17.5);
      ctx.lineTo(32.525, 17.5);
      ctx.bezierCurveTo(33.9057, 17.5, 35.025, 18.6193, 35.025, 20);
      ctx.bezierCurveTo(35.025, 21.3807, 33.9057, 22.5, 32.525, 22.5);
      ctx.lineTo(32.5, 22.5);
      ctx.bezierCurveTo(31.1193, 22.5, 30, 21.3807, 30, 20);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(15, 32.5);
      ctx.bezierCurveTo(15, 31.1193, 16.1193, 30, 17.5, 30);
      ctx.lineTo(32.5, 30);
      ctx.bezierCurveTo(33.8807, 30, 35, 31.1193, 35, 32.5);
      ctx.bezierCurveTo(35, 33.8807, 33.8807, 35, 32.5, 35);
      ctx.lineTo(17.5, 35);
      ctx.bezierCurveTo(16.1193, 35, 15, 33.8807, 15, 32.5);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  FACE_4: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = secondaryColor;
      ctx.save();
      ctx.font = "10px sans-serif";

      ctx.beginPath();
      ctx.arc(25, 25, 22, 0, 6.283185307179586, false);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(15.4329, 1.90301);
      ctx.bezierCurveTo(18.4661, 0.646644, 21.717, 0, 25, 0);
      ctx.bezierCurveTo(28.283, 0, 31.5339, 0.646644, 34.5671, 1.90301);
      ctx.bezierCurveTo(37.6002, 3.15938, 40.3562, 5.00087, 42.6777, 7.32233);
      ctx.bezierCurveTo(44.9991, 9.64379, 46.8406, 12.3998, 48.097, 15.4329);
      ctx.bezierCurveTo(49.3534, 18.4661, 50, 21.717, 50, 25);
      ctx.bezierCurveTo(50, 28.283, 49.3534, 31.5339, 48.097, 34.5671);
      ctx.bezierCurveTo(46.8406, 37.6002, 44.9991, 40.3562, 42.6777, 42.6777);
      ctx.bezierCurveTo(40.3562, 44.9991, 37.6002, 46.8406, 34.5671, 48.097);
      ctx.bezierCurveTo(31.5339, 49.3534, 28.283, 50, 25, 50);
      ctx.bezierCurveTo(21.717, 50, 18.4661, 49.3534, 15.4329, 48.097);
      ctx.bezierCurveTo(12.3998, 46.8406, 9.64379, 44.9991, 7.32233, 42.6777);
      ctx.bezierCurveTo(5.00087, 40.3562, 3.15938, 37.6002, 1.90301, 34.5671);
      ctx.bezierCurveTo(0.646644, 31.5339, 0, 28.283, 0, 25);
      ctx.bezierCurveTo(0, 21.717, 0.646644, 18.4661, 1.90301, 15.4329);
      ctx.bezierCurveTo(3.15938, 12.3998, 5.00087, 9.6438, 7.32233, 7.32233);
      ctx.bezierCurveTo(9.6438, 5.00087, 12.3998, 3.15938, 15.4329, 1.90301);
      ctx.closePath();
      ctx.moveTo(25, 5);
      ctx.bezierCurveTo(22.3736, 5, 19.7728, 5.51732, 17.3463, 6.52241);
      ctx.bezierCurveTo(14.9198, 7.5275, 12.715, 9.00069, 10.8579, 10.8579);
      ctx.bezierCurveTo(9.00069, 12.715, 7.5275, 14.9198, 6.52241, 17.3463);
      ctx.bezierCurveTo(5.51731, 19.7728, 5, 22.3736, 5, 25);
      ctx.bezierCurveTo(5, 27.6264, 5.51731, 30.2272, 6.52241, 32.6537);
      ctx.bezierCurveTo(7.5275, 35.0802, 9.00069, 37.285, 10.8579, 39.1421);
      ctx.bezierCurveTo(12.715, 40.9993, 14.9198, 42.4725, 17.3463, 43.4776);
      ctx.bezierCurveTo(19.7728, 44.4827, 22.3736, 45, 25, 45);
      ctx.bezierCurveTo(27.6264, 45, 30.2272, 44.4827, 32.6537, 43.4776);
      ctx.bezierCurveTo(35.0802, 42.4725, 37.285, 40.9993, 39.1421, 39.1421);
      ctx.bezierCurveTo(40.9993, 37.285, 42.4725, 35.0802, 43.4776, 32.6537);
      ctx.bezierCurveTo(44.4827, 30.2272, 45, 27.6264, 45, 25);
      ctx.bezierCurveTo(45, 22.3736, 44.4827, 19.7728, 43.4776, 17.3463);
      ctx.bezierCurveTo(42.4725, 14.9198, 40.9993, 12.715, 39.1421, 10.8579);
      ctx.bezierCurveTo(37.285, 9.00069, 35.0802, 7.5275, 32.6537, 6.52241);
      ctx.bezierCurveTo(30.2272, 5.51732, 27.6264, 5, 25, 5);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(15, 20);
      ctx.bezierCurveTo(15, 18.6193, 16.1193, 17.5, 17.5, 17.5);
      ctx.lineTo(17.525, 17.5);
      ctx.bezierCurveTo(18.9057, 17.5, 20.025, 18.6193, 20.025, 20);
      ctx.bezierCurveTo(20.025, 21.3807, 18.9057, 22.5, 17.525, 22.5);
      ctx.lineTo(17.5, 22.5);
      ctx.bezierCurveTo(16.1193, 22.5, 15, 21.3807, 15, 20);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(30, 20);
      ctx.bezierCurveTo(30, 18.6193, 31.1193, 17.5, 32.5, 17.5);
      ctx.lineTo(32.525, 17.5);
      ctx.bezierCurveTo(33.9057, 17.5, 35.025, 18.6193, 35.025, 20);
      ctx.bezierCurveTo(35.025, 21.3807, 33.9057, 22.5, 32.525, 22.5);
      ctx.lineTo(32.5, 22.5);
      ctx.bezierCurveTo(31.1193, 22.5, 30, 21.3807, 30, 20);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(33.5766, 33.744);
      ctx.bezierCurveTo(28.833, 33.4142, 24.1069, 34.5957, 20.0766, 37.119);
      ctx.bezierCurveTo(18.9063, 37.8517, 17.3637, 37.4969, 16.631, 36.3266);
      ctx.bezierCurveTo(15.8983, 35.1563, 16.2531, 33.6137, 17.4234, 32.881);
      ctx.bezierCurveTo(22.3493, 29.7971, 28.1257, 28.353, 33.9234, 28.756);
      ctx.bezierCurveTo(35.3008, 28.8518, 36.3397, 30.046, 36.244, 31.4234);
      ctx.bezierCurveTo(36.1482, 32.8008, 34.954, 33.8397, 33.5766, 33.744);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  FACE_5: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = secondaryColor;
      ctx.save();
      ctx.font = "10px sans-serif";

      ctx.beginPath();
      ctx.arc(25, 25, 22, 0, 6.283185307179586, false);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(25, 5);
      ctx.bezierCurveTo(22.3736, 5, 19.7728, 5.51731, 17.3463, 6.52241);
      ctx.bezierCurveTo(14.9198, 7.5275, 12.715, 9.00069, 10.8579, 10.8579);
      ctx.bezierCurveTo(9.00069, 12.715, 7.5275, 14.9198, 6.52241, 17.3463);
      ctx.bezierCurveTo(5.51732, 19.7728, 5, 22.3736, 5, 25);
      ctx.bezierCurveTo(5, 27.6264, 5.51732, 30.2272, 6.52241, 32.6537);
      ctx.bezierCurveTo(7.5275, 35.0802, 9.00069, 37.285, 10.8579, 39.1421);
      ctx.bezierCurveTo(12.715, 40.9993, 14.9198, 42.4725, 17.3463, 43.4776);
      ctx.bezierCurveTo(19.7728, 44.4827, 22.3736, 45, 25, 45);
      ctx.bezierCurveTo(30.3043, 45, 35.3914, 42.8929, 39.1421, 39.1421);
      ctx.bezierCurveTo(42.8929, 35.3914, 45, 30.3043, 45, 25);
      ctx.bezierCurveTo(45, 19.6957, 42.8929, 14.6086, 39.1421, 10.8579);
      ctx.bezierCurveTo(35.3914, 7.10714, 30.3043, 5, 25, 5);
      ctx.closePath();
      ctx.moveTo(15.4329, 1.90301);
      ctx.bezierCurveTo(18.4661, 0.646644, 21.717, 0, 25, 0);
      ctx.bezierCurveTo(
        31.6304,
        1.49012e-7,
        37.9893,
        2.63392,
        42.6777,
        7.32233
      );
      ctx.bezierCurveTo(47.3661, 12.0107, 50, 18.3696, 50, 25);
      ctx.bezierCurveTo(50, 31.6304, 47.3661, 37.9893, 42.6777, 42.6777);
      ctx.bezierCurveTo(37.9893, 47.3661, 31.6304, 50, 25, 50);
      ctx.bezierCurveTo(21.717, 50, 18.4661, 49.3534, 15.4329, 48.097);
      ctx.bezierCurveTo(12.3998, 46.8406, 9.64379, 44.9991, 7.32233, 42.6777);
      ctx.bezierCurveTo(5.00087, 40.3562, 3.15938, 37.6002, 1.90301, 34.5671);
      ctx.bezierCurveTo(0.646644, 31.5339, 0, 28.283, 0, 25);
      ctx.bezierCurveTo(0, 21.717, 0.646644, 18.4661, 1.90301, 15.4329);
      ctx.bezierCurveTo(3.15938, 12.3998, 5.00087, 9.6438, 7.32233, 7.32233);
      ctx.bezierCurveTo(9.6438, 5.00087, 12.3998, 3.15938, 15.4329, 1.90301);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(12.7639, 16.382);
      ctx.bezierCurveTo(13.3814, 15.147, 14.8831, 14.6465, 16.118, 15.2639);
      ctx.lineTo(21.118, 17.7639);
      ctx.bezierCurveTo(22.353, 18.3814, 22.8535, 19.8831, 22.2361, 21.118);
      ctx.bezierCurveTo(21.6186, 22.353, 20.1169, 22.8535, 18.882, 22.2361);
      ctx.lineTo(13.882, 19.7361);
      ctx.bezierCurveTo(12.647, 19.1186, 12.1465, 17.6169, 12.7639, 16.382);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(37.2361, 16.382);
      ctx.bezierCurveTo(37.8535, 17.6169, 37.353, 19.1186, 36.118, 19.7361);
      ctx.lineTo(31.118, 22.2361);
      ctx.bezierCurveTo(29.8831, 22.8535, 28.3814, 22.353, 27.7639, 21.118);
      ctx.bezierCurveTo(27.1465, 19.8831, 27.647, 18.3814, 28.882, 17.7639);
      ctx.lineTo(33.882, 15.2639);
      ctx.bezierCurveTo(35.1169, 14.6465, 36.6186, 15.147, 37.2361, 16.382);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(20.6418, 30.8772);
      ctx.bezierCurveTo(22.0217, 30.2974, 23.5033, 29.9987, 25, 29.9987);
      ctx.bezierCurveTo(26.4967, 29.9987, 27.9783, 30.2974, 29.3582, 30.8772);
      ctx.bezierCurveTo(30.738, 31.457, 31.9882, 32.3063, 33.0357, 33.3754);
      ctx.bezierCurveTo(34.002, 34.3616, 33.9859, 35.9444, 32.9996, 36.9107);
      ctx.bezierCurveTo(32.0134, 37.877, 30.4306, 37.8609, 29.4643, 36.8746);
      ctx.bezierCurveTo(28.8824, 36.2807, 28.1878, 35.8089, 27.4212, 35.4868);
      ctx.bezierCurveTo(26.6546, 35.1646, 25.8315, 34.9987, 25, 34.9987);
      ctx.bezierCurveTo(24.1685, 34.9987, 23.3454, 35.1646, 22.5788, 35.4868);
      ctx.bezierCurveTo(21.8122, 35.8089, 21.1176, 36.2807, 20.5357, 36.8746);
      ctx.bezierCurveTo(19.5694, 37.8609, 17.9866, 37.877, 17.0004, 36.9107);
      ctx.bezierCurveTo(16.0141, 35.9444, 15.998, 34.3616, 16.9643, 33.3754);
      ctx.bezierCurveTo(18.0118, 32.3063, 19.262, 31.457, 20.6418, 30.8772);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  FACE_6: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = secondaryColor;
      ctx.save();
      ctx.font = "10px sans-serif";

      ctx.beginPath();
      ctx.arc(25, 25, 22, 0, 6.283185307179586, false);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(25, 5);
      ctx.bezierCurveTo(22.3736, 5, 19.7728, 5.51731, 17.3463, 6.52241);
      ctx.bezierCurveTo(14.9198, 7.5275, 12.715, 9.00069, 10.8579, 10.8579);
      ctx.bezierCurveTo(9.00069, 12.715, 7.5275, 14.9198, 6.52241, 17.3463);
      ctx.bezierCurveTo(5.51732, 19.7728, 5, 22.3736, 5, 25);
      ctx.bezierCurveTo(5, 27.6264, 5.51732, 30.2272, 6.52241, 32.6537);
      ctx.bezierCurveTo(7.5275, 35.0802, 9.00069, 37.285, 10.8579, 39.1421);
      ctx.bezierCurveTo(12.715, 40.9993, 14.9198, 42.4725, 17.3463, 43.4776);
      ctx.bezierCurveTo(19.7728, 44.4827, 22.3736, 45, 25, 45);
      ctx.bezierCurveTo(30.3043, 45, 35.3914, 42.8929, 39.1421, 39.1421);
      ctx.bezierCurveTo(42.8929, 35.3914, 45, 30.3043, 45, 25);
      ctx.bezierCurveTo(45, 19.6957, 42.8929, 14.6086, 39.1421, 10.8579);
      ctx.bezierCurveTo(35.3914, 7.10714, 30.3043, 5, 25, 5);
      ctx.closePath();
      ctx.moveTo(15.4329, 1.90301);
      ctx.bezierCurveTo(18.4661, 0.646644, 21.717, 0, 25, 0);
      ctx.bezierCurveTo(
        31.6304,
        1.49012e-7,
        37.9893,
        2.63392,
        42.6777,
        7.32233
      );
      ctx.bezierCurveTo(47.3661, 12.0107, 50, 18.3696, 50, 25);
      ctx.bezierCurveTo(50, 31.6304, 47.3661, 37.9893, 42.6777, 42.6777);
      ctx.bezierCurveTo(37.9893, 47.3661, 31.6304, 50, 25, 50);
      ctx.bezierCurveTo(21.717, 50, 18.4661, 49.3534, 15.4329, 48.097);
      ctx.bezierCurveTo(12.3998, 46.8406, 9.64379, 44.9991, 7.32233, 42.6777);
      ctx.bezierCurveTo(5.00087, 40.3562, 3.15938, 37.6002, 1.90301, 34.5671);
      ctx.bezierCurveTo(0.646644, 31.5339, 0, 28.283, 0, 25);
      ctx.bezierCurveTo(0, 21.717, 0.646644, 18.4661, 1.90301, 15.4329);
      ctx.bezierCurveTo(3.15938, 12.3998, 5.00087, 9.6438, 7.32233, 7.32233);
      ctx.bezierCurveTo(9.6438, 5.00087, 12.3998, 3.15938, 15.4329, 1.90301);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(15.7322, 30.7322);
      ctx.bezierCurveTo(16.5749, 29.8896, 17.8952, 29.7588, 18.8868, 30.4199);
      ctx.lineTo(21.25, 31.9954);
      ctx.lineTo(23.6133, 30.4199);
      ctx.bezierCurveTo(24.453, 29.86, 25.547, 29.86, 26.3868, 30.4199);
      ctx.lineTo(28.75, 31.9954);
      ctx.lineTo(31.1133, 30.4199);
      ctx.bezierCurveTo(32.1048, 29.7588, 33.4251, 29.8896, 34.2678, 30.7322);
      ctx.lineTo(36.7678, 33.2322);
      ctx.bezierCurveTo(37.7441, 34.2085, 37.7441, 35.7915, 36.7678, 36.7678);
      ctx.bezierCurveTo(35.7915, 37.7441, 34.2085, 37.7441, 33.2322, 36.7678);
      ctx.lineTo(32.1815, 35.717);
      ctx.lineTo(30.1368, 37.0801);
      ctx.bezierCurveTo(29.297, 37.64, 28.203, 37.64, 27.3633, 37.0801);
      ctx.lineTo(25, 35.5046);
      ctx.lineTo(22.6368, 37.0801);
      ctx.bezierCurveTo(21.797, 37.64, 20.703, 37.64, 19.8633, 37.0801);
      ctx.lineTo(17.8185, 35.717);
      ctx.lineTo(16.7678, 36.7678);
      ctx.bezierCurveTo(15.7915, 37.7441, 14.2085, 37.7441, 13.2322, 36.7678);
      ctx.bezierCurveTo(12.2559, 35.7915, 12.2559, 34.2085, 13.2322, 33.2322);
      ctx.lineTo(15.7322, 30.7322);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(14.4822, 14.4822);
      ctx.bezierCurveTo(15.4585, 13.5059, 17.0415, 13.5059, 18.0178, 14.4822);
      ctx.lineTo(21.7678, 18.2322);
      ctx.bezierCurveTo(22.7441, 19.2085, 22.7441, 20.7915, 21.7678, 21.7678);
      ctx.lineTo(18.0178, 25.5178);
      ctx.bezierCurveTo(17.0415, 26.4941, 15.4585, 26.4941, 14.4822, 25.5178);
      ctx.bezierCurveTo(13.5059, 24.5415, 13.5059, 22.9585, 14.4822, 21.9822);
      ctx.lineTo(16.4645, 20);
      ctx.lineTo(14.4822, 18.0178);
      ctx.bezierCurveTo(13.5059, 17.0415, 13.5059, 15.4585, 14.4822, 14.4822);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(35.5178, 14.4822);
      ctx.bezierCurveTo(36.4941, 15.4585, 36.4941, 17.0415, 35.5178, 18.0178);
      ctx.lineTo(33.5355, 20);
      ctx.lineTo(35.5178, 21.9822);
      ctx.bezierCurveTo(36.4941, 22.9585, 36.4941, 24.5415, 35.5178, 25.5178);
      ctx.bezierCurveTo(34.5415, 26.4941, 32.9585, 26.4941, 31.9822, 25.5178);
      ctx.lineTo(28.2322, 21.7678);
      ctx.bezierCurveTo(27.2559, 20.7915, 27.2559, 19.2085, 28.2322, 18.2322);
      ctx.lineTo(31.9822, 14.4822);
      ctx.bezierCurveTo(32.9585, 13.5059, 34.5415, 13.5059, 35.5178, 14.4822);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  FACE_7: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = secondaryColor;
      ctx.save();
      ctx.font = "10px sans-serif";

      ctx.beginPath();
      ctx.arc(25, 25, 22, 0, 6.283185307179586, false);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(15.4329, 2.90301);
      ctx.bezierCurveTo(18.4661, 1.64664, 21.717, 1, 25, 1);
      ctx.bezierCurveTo(28.283, 1, 31.5339, 1.64664, 34.5671, 2.90301);
      ctx.bezierCurveTo(37.6002, 4.15938, 40.3562, 6.00087, 42.6777, 8.32233);
      ctx.bezierCurveTo(44.9991, 10.6438, 46.8406, 13.3998, 48.097, 16.4329);
      ctx.bezierCurveTo(49.3534, 19.4661, 50, 22.717, 50, 26);
      ctx.bezierCurveTo(50, 29.283, 49.3534, 32.5339, 48.097, 35.5671);
      ctx.bezierCurveTo(46.8406, 38.6002, 44.9991, 41.3562, 42.6777, 43.6777);
      ctx.bezierCurveTo(40.3562, 45.9991, 37.6002, 47.8406, 34.5671, 49.097);
      ctx.bezierCurveTo(31.5339, 50.3534, 28.283, 51, 25, 51);
      ctx.bezierCurveTo(21.717, 51, 18.4661, 50.3534, 15.4329, 49.097);
      ctx.bezierCurveTo(12.3998, 47.8406, 9.64379, 45.9991, 7.32233, 43.6777);
      ctx.bezierCurveTo(5.00087, 41.3562, 3.15938, 38.6002, 1.90301, 35.5671);
      ctx.bezierCurveTo(0.646644, 32.5339, 0, 29.283, 0, 26);
      ctx.bezierCurveTo(0, 22.717, 0.646644, 19.4661, 1.90301, 16.4329);
      ctx.bezierCurveTo(3.15938, 13.3998, 5.00087, 10.6438, 7.32233, 8.32233);
      ctx.bezierCurveTo(9.6438, 6.00087, 12.3998, 4.15938, 15.4329, 2.90301);
      ctx.closePath();
      ctx.moveTo(25, 6);
      ctx.bezierCurveTo(22.3736, 6, 19.7728, 6.51732, 17.3463, 7.52241);
      ctx.bezierCurveTo(14.9198, 8.5275, 12.715, 10.0007, 10.8579, 11.8579);
      ctx.bezierCurveTo(9.00069, 13.715, 7.5275, 15.9198, 6.52241, 18.3463);
      ctx.bezierCurveTo(5.51731, 20.7728, 5, 23.3736, 5, 26);
      ctx.bezierCurveTo(5, 28.6264, 5.51731, 31.2272, 6.52241, 33.6537);
      ctx.bezierCurveTo(7.5275, 36.0802, 9.00069, 38.285, 10.8579, 40.1421);
      ctx.bezierCurveTo(12.715, 41.9993, 14.9198, 43.4725, 17.3463, 44.4776);
      ctx.bezierCurveTo(19.7728, 45.4827, 22.3736, 46, 25, 46);
      ctx.bezierCurveTo(27.6264, 46, 30.2272, 45.4827, 32.6537, 44.4776);
      ctx.bezierCurveTo(35.0802, 43.4725, 37.285, 41.9993, 39.1421, 40.1421);
      ctx.bezierCurveTo(40.9993, 38.285, 42.4725, 36.0802, 43.4776, 33.6537);
      ctx.bezierCurveTo(44.4827, 31.2272, 45, 28.6264, 45, 26);
      ctx.bezierCurveTo(45, 23.3736, 44.4827, 20.7728, 43.4776, 18.3463);
      ctx.bezierCurveTo(42.4725, 15.9198, 40.9993, 13.715, 39.1421, 11.8579);
      ctx.bezierCurveTo(37.285, 10.0007, 35.0802, 8.5275, 32.6537, 7.52241);
      ctx.bezierCurveTo(30.2272, 6.51732, 27.6264, 6, 25, 6);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(20.6418, 31.8772);
      ctx.bezierCurveTo(22.0217, 31.2974, 23.5033, 30.9987, 25, 30.9987);
      ctx.bezierCurveTo(26.4967, 30.9987, 27.9783, 31.2974, 29.3582, 31.8772);
      ctx.bezierCurveTo(30.738, 32.457, 31.9882, 33.3063, 33.0357, 34.3754);
      ctx.bezierCurveTo(34.002, 35.3616, 33.9859, 36.9444, 32.9996, 37.9107);
      ctx.bezierCurveTo(32.0134, 38.877, 30.4306, 38.8609, 29.4643, 37.8746);
      ctx.bezierCurveTo(28.8824, 37.2807, 28.1878, 36.8089, 27.4212, 36.4868);
      ctx.bezierCurveTo(26.6546, 36.1646, 25.8315, 35.9987, 25, 35.9987);
      ctx.bezierCurveTo(24.1685, 35.9987, 23.3454, 36.1646, 22.5788, 36.4868);
      ctx.bezierCurveTo(21.8122, 36.8089, 21.1176, 37.2807, 20.5357, 37.8746);
      ctx.bezierCurveTo(19.5694, 38.8609, 17.9866, 38.877, 17.0004, 37.9107);
      ctx.bezierCurveTo(16.0141, 36.9444, 15.998, 35.3616, 16.9643, 34.3754);
      ctx.bezierCurveTo(18.0118, 33.3063, 19.262, 32.457, 20.6418, 31.8772);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(13.2322, 16.7322);
      ctx.bezierCurveTo(14.2085, 15.7559, 15.7915, 15.7559, 16.7678, 16.7322);
      ctx.lineTo(21.7678, 21.7322);
      ctx.bezierCurveTo(22.7441, 22.7085, 22.7441, 24.2915, 21.7678, 25.2678);
      ctx.bezierCurveTo(20.7915, 26.2441, 19.2085, 26.2441, 18.2322, 25.2678);
      ctx.lineTo(13.2322, 20.2678);
      ctx.bezierCurveTo(12.2559, 19.2915, 12.2559, 17.7085, 13.2322, 16.7322);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(21.7678, 16.7322);
      ctx.bezierCurveTo(22.7441, 17.7085, 22.7441, 19.2915, 21.7678, 20.2678);
      ctx.lineTo(16.7678, 25.2678);
      ctx.bezierCurveTo(15.7915, 26.2441, 14.2085, 26.2441, 13.2322, 25.2678);
      ctx.bezierCurveTo(12.2559, 24.2915, 12.2559, 22.7085, 13.2322, 21.7322);
      ctx.lineTo(18.2322, 16.7322);
      ctx.bezierCurveTo(19.2085, 15.7559, 20.7915, 15.7559, 21.7678, 16.7322);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(28.2322, 16.7322);
      ctx.bezierCurveTo(29.2085, 15.7559, 30.7915, 15.7559, 31.7678, 16.7322);
      ctx.lineTo(36.7678, 21.7322);
      ctx.bezierCurveTo(37.7441, 22.7085, 37.7441, 24.2915, 36.7678, 25.2678);
      ctx.bezierCurveTo(35.7915, 26.2441, 34.2085, 26.2441, 33.2322, 25.2678);
      ctx.lineTo(28.2322, 20.2678);
      ctx.bezierCurveTo(27.2559, 19.2915, 27.2559, 17.7085, 28.2322, 16.7322);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(36.7678, 16.7322);
      ctx.bezierCurveTo(37.7441, 17.7085, 37.7441, 19.2915, 36.7678, 20.2678);
      ctx.lineTo(31.7678, 25.2678);
      ctx.bezierCurveTo(30.7915, 26.2441, 29.2085, 26.2441, 28.2322, 25.2678);
      ctx.bezierCurveTo(27.2559, 24.2915, 27.2559, 22.7085, 28.2322, 21.7322);
      ctx.lineTo(33.2322, 16.7322);
      ctx.bezierCurveTo(34.2085, 15.7559, 35.7915, 15.7559, 36.7678, 16.7322);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  SNOW_CLOUD: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = secondaryColor;
      ctx.save();
      ctx.font = "10px sans-serif";

      ctx.beginPath();
      ctx.moveTo(31.1855, 29.2061);
      ctx.bezierCurveTo(29.325, 30.1406, 27.2239, 30.6667, 25, 30.6667);
      ctx.bezierCurveTo(22.8507, 30.6667, 20.8162, 30.1753, 19.0027, 29.2989);
      ctx.bezierCurveTo(17.4513, 30.1699, 15.6614, 30.6667, 13.7556, 30.6667);
      ctx.bezierCurveTo(7.82769, 30.6667, 3.02222, 25.8612, 3.02222, 19.9333);
      ctx.bezierCurveTo(3.02222, 14.0835, 7.70208, 9.32664, 13.5222, 9.20249);
      ctx.bezierCurveTo(15.9975, 5.50274, 20.2143, 3.06667, 25, 3.06667);
      ctx.bezierCurveTo(31.7831, 3.06667, 37.4231, 7.96052, 38.582, 14.41);
      ctx.bezierCurveTo(42.7566, 15.0439, 45.9556, 18.6484, 45.9556, 23);
      ctx.bezierCurveTo(45.9556, 27.7987, 42.0654, 31.6889, 37.2667, 31.6889);
      ctx.bezierCurveTo(34.8991, 31.6889, 32.7527, 30.7419, 31.1855, 29.2061);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(11.575, 42);
      ctx.bezierCurveTo(10.7525, 42, 10.0573, 41.7181, 9.48938, 41.1542);
      ctx.bezierCurveTo(8.92146, 40.5903, 8.6375, 39.9, 8.6375, 39.0833);
      ctx.bezierCurveTo(8.6375, 38.2667, 8.92146, 37.5764, 9.48938, 37.0125);
      ctx.bezierCurveTo(10.0573, 36.4486, 10.7525, 36.1667, 11.575, 36.1667);
      ctx.bezierCurveTo(12.3975, 36.1667, 13.0927, 36.4486, 13.6606, 37.0125);
      ctx.bezierCurveTo(14.2285, 37.5764, 14.5125, 38.2667, 14.5125, 39.0833);
      ctx.bezierCurveTo(14.5125, 39.9, 14.2285, 40.5903, 13.6606, 41.1542);
      ctx.bezierCurveTo(13.0927, 41.7181, 12.3975, 42, 11.575, 42);
      ctx.closePath();
      ctx.moveTo(18.625, 49);
      ctx.bezierCurveTo(17.8025, 49, 17.1073, 48.7181, 16.5394, 48.1542);
      ctx.bezierCurveTo(15.9715, 47.5903, 15.6875, 46.9, 15.6875, 46.0833);
      ctx.bezierCurveTo(15.6875, 45.2667, 15.9715, 44.5764, 16.5394, 44.0125);
      ctx.bezierCurveTo(17.1073, 43.4486, 17.8025, 43.1667, 18.625, 43.1667);
      ctx.bezierCurveTo(19.4475, 43.1667, 20.1427, 43.4486, 20.7106, 44.0125);
      ctx.bezierCurveTo(21.2785, 44.5764, 21.5625, 45.2667, 21.5625, 46.0833);
      ctx.bezierCurveTo(21.5625, 46.9, 21.2785, 47.5903, 20.7106, 48.1542);
      ctx.bezierCurveTo(20.1427, 48.7181, 19.4475, 49, 18.625, 49);
      ctx.closePath();
      ctx.moveTo(25.675, 42);
      ctx.bezierCurveTo(24.8525, 42, 24.1573, 41.7181, 23.5894, 41.1542);
      ctx.bezierCurveTo(23.0215, 40.5903, 22.7375, 39.9, 22.7375, 39.0833);
      ctx.bezierCurveTo(22.7375, 38.2667, 23.0215, 37.5764, 23.5894, 37.0125);
      ctx.bezierCurveTo(24.1573, 36.4486, 24.8525, 36.1667, 25.675, 36.1667);
      ctx.bezierCurveTo(26.4975, 36.1667, 27.1927, 36.4486, 27.7606, 37.0125);
      ctx.bezierCurveTo(28.3285, 37.5764, 28.6125, 38.2667, 28.6125, 39.0833);
      ctx.bezierCurveTo(28.6125, 39.9, 28.3285, 40.5903, 27.7606, 41.1542);
      ctx.bezierCurveTo(27.1927, 41.7181, 26.4975, 42, 25.675, 42);
      ctx.closePath();
      ctx.moveTo(39.775, 42);
      ctx.bezierCurveTo(38.9525, 42, 38.2573, 41.7181, 37.6894, 41.1542);
      ctx.bezierCurveTo(37.1215, 40.5903, 36.8375, 39.9, 36.8375, 39.0833);
      ctx.bezierCurveTo(36.8375, 38.2667, 37.1215, 37.5764, 37.6894, 37.0125);
      ctx.bezierCurveTo(38.2573, 36.4486, 38.9525, 36.1667, 39.775, 36.1667);
      ctx.bezierCurveTo(40.5975, 36.1667, 41.2927, 36.4486, 41.8606, 37.0125);
      ctx.bezierCurveTo(42.4285, 37.5764, 42.7125, 38.2667, 42.7125, 39.0833);
      ctx.bezierCurveTo(42.7125, 39.9, 42.4285, 40.5903, 41.8606, 41.1542);
      ctx.bezierCurveTo(41.2927, 41.7181, 40.5975, 42, 39.775, 42);
      ctx.closePath();
      ctx.moveTo(32.725, 49);
      ctx.bezierCurveTo(31.9025, 49, 31.2073, 48.7181, 30.6394, 48.1542);
      ctx.bezierCurveTo(30.0715, 47.5903, 29.7875, 46.9, 29.7875, 46.0833);
      ctx.bezierCurveTo(29.7875, 45.2667, 30.0715, 44.5764, 30.6394, 44.0125);
      ctx.bezierCurveTo(31.2073, 43.4486, 31.9025, 43.1667, 32.725, 43.1667);
      ctx.bezierCurveTo(33.5475, 43.1667, 34.2427, 43.4486, 34.8106, 44.0125);
      ctx.bezierCurveTo(35.3785, 44.5764, 35.6625, 45.2667, 35.6625, 46.0833);
      ctx.bezierCurveTo(35.6625, 46.9, 35.3785, 47.5903, 34.8106, 48.1542);
      ctx.bezierCurveTo(34.2427, 48.7181, 33.5475, 49, 32.725, 49);
      ctx.closePath();
      ctx.moveTo(13.925, 32.6667);
      ctx.bezierCurveTo(10.3608, 32.6667, 7.31563, 31.4125, 4.78938, 28.9042);
      ctx.bezierCurveTo(2.26312, 26.3958, 1, 23.3722, 1, 19.8333);
      ctx.bezierCurveTo(1, 16.6056, 2.07708, 13.7861, 4.23125, 11.375);
      ctx.bezierCurveTo(6.38542, 8.96389, 9.04875, 7.54444, 12.2212, 7.11667);
      ctx.bezierCurveTo(13.4746, 4.9, 15.1881, 3.15972, 17.3619, 1.89583);
      ctx.bezierCurveTo(19.5356, 0.631944, 21.915, 0, 24.5, 0);
      ctx.bezierCurveTo(28.025, 0, 31.0898, 1.11806, 33.6944, 3.35417);
      ctx.bezierCurveTo(36.299, 5.59028, 37.8754, 8.38056, 38.4237, 11.725);
      ctx.bezierCurveTo(41.1263, 11.9583, 43.3979, 13.0667, 45.2388, 15.05);
      ctx.bezierCurveTo(47.0796, 17.0333, 48, 19.4056, 48, 22.1667);
      ctx.bezierCurveTo(48, 25.0833, 46.9719, 27.5625, 44.9156, 29.6042);
      ctx.bezierCurveTo(42.8594, 31.6458, 40.3625, 32.6667, 37.425, 32.6667);
      ctx.lineTo(13.925, 32.6667);
      ctx.closePath();
      ctx.moveTo(13.925, 28);
      ctx.lineTo(37.425, 28);
      ctx.bezierCurveTo(39.07, 28, 40.4604, 27.4361, 41.5962, 26.3083);
      ctx.bezierCurveTo(42.7321, 25.1806, 43.3, 23.8, 43.3, 22.1667);
      ctx.bezierCurveTo(43.3, 20.5333, 42.7321, 19.1528, 41.5962, 18.025);
      ctx.bezierCurveTo(40.4604, 16.8972, 39.07, 16.3333, 37.425, 16.3333);
      ctx.lineTo(33.9, 16.3333);
      ctx.lineTo(33.9, 14);
      ctx.bezierCurveTo(33.9, 11.4333, 32.9796, 9.23611, 31.1388, 7.40833);
      ctx.bezierCurveTo(29.2979, 5.58056, 27.085, 4.66667, 24.5, 4.66667);
      ctx.bezierCurveTo(22.62, 4.66667, 20.9065, 5.17222, 19.3594, 6.18333);
      ctx.bezierCurveTo(17.8123, 7.19444, 16.6471, 8.55556, 15.8638, 10.2667);
      ctx.lineTo(15.2763, 11.6667);
      ctx.lineTo(13.8075, 11.6667);
      ctx.bezierCurveTo(11.575, 11.7444, 9.66562, 12.5708, 8.07937, 14.1458);
      ctx.bezierCurveTo(6.49312, 15.7208, 5.7, 17.6167, 5.7, 19.8333);
      ctx.bezierCurveTo(5.7, 22.0889, 6.50292, 24.0139, 8.10875, 25.6083);
      ctx.bezierCurveTo(9.71458, 27.2028, 11.6533, 28, 13.925, 28);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  WIND: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = color;
      ctx.save();
      ctx.font = "10px sans-serif";

      ctx.beginPath();
      ctx.moveTo(24.225, 46);
      ctx.bezierCurveTo(22.1, 46, 20.2937, 45.2623, 18.8062, 43.7868);
      ctx.bezierCurveTo(17.3188, 42.3113, 16.575, 40.5196, 16.575, 38.4118);
      ctx.lineTo(21.675, 38.4118);
      ctx.bezierCurveTo(21.675, 39.1284, 21.9194, 39.7292, 22.4081, 40.214);
      ctx.bezierCurveTo(22.8969, 40.6988, 23.5025, 40.9412, 24.225, 40.9412);
      ctx.bezierCurveTo(24.9475, 40.9412, 25.5531, 40.6988, 26.0419, 40.214);
      ctx.bezierCurveTo(26.5306, 39.7292, 26.775, 39.1284, 26.775, 38.4118);
      ctx.bezierCurveTo(26.775, 37.6951, 26.5306, 37.0944, 26.0419, 36.6096);
      ctx.bezierCurveTo(25.5531, 36.1248, 24.9475, 35.8824, 24.225, 35.8824);
      ctx.lineTo(0, 35.8824);
      ctx.lineTo(0, 30.8235);
      ctx.lineTo(24.225, 30.8235);
      ctx.bezierCurveTo(26.35, 30.8235, 28.1562, 31.5613, 29.6437, 33.0368);
      ctx.bezierCurveTo(31.1313, 34.5123, 31.875, 36.3039, 31.875, 38.4118);
      ctx.bezierCurveTo(31.875, 40.5196, 31.1313, 42.3113, 29.6437, 43.7868);
      ctx.bezierCurveTo(28.1562, 45.2623, 26.35, 46, 24.225, 46);
      ctx.closePath();
      ctx.moveTo(0, 20.7059);
      ctx.lineTo(0, 15.6471);
      ctx.lineTo(34.425, 15.6471);
      ctx.bezierCurveTo(35.53, 15.6471, 36.4437, 15.2887, 37.1662, 14.5721);
      ctx.bezierCurveTo(37.8887, 13.8554, 38.25, 12.949, 38.25, 11.8529);
      ctx.bezierCurveTo(38.25, 10.7569, 37.8887, 9.85049, 37.1662, 9.13382);
      ctx.bezierCurveTo(36.4437, 8.41716, 35.53, 8.05882, 34.425, 8.05882);
      ctx.bezierCurveTo(33.32, 8.05882, 32.4062, 8.41716, 31.6838, 9.13382);
      ctx.bezierCurveTo(30.9613, 9.85049, 30.6, 10.7569, 30.6, 11.8529);
      ctx.lineTo(25.5, 11.8529);
      ctx.bezierCurveTo(25.5, 9.36569, 26.3606, 7.26838, 28.0819, 5.56103);
      ctx.bezierCurveTo(29.8031, 3.85368, 31.9175, 3, 34.425, 3);
      ctx.bezierCurveTo(36.9325, 3, 39.0469, 3.85368, 40.7681, 5.56103);
      ctx.bezierCurveTo(42.4894, 7.26838, 43.35, 9.36569, 43.35, 11.8529);
      ctx.bezierCurveTo(43.35, 14.3402, 42.4894, 16.4375, 40.7681, 18.1449);
      ctx.bezierCurveTo(39.0469, 19.8522, 36.9325, 20.7059, 34.425, 20.7059);
      ctx.lineTo(0, 20.7059);
      ctx.closePath();
      ctx.moveTo(42.075, 40.9412);
      ctx.lineTo(42.075, 35.8824);
      ctx.bezierCurveTo(43.18, 35.8824, 44.0938, 35.524, 44.8162, 34.8074);
      ctx.bezierCurveTo(45.5387, 34.0907, 45.9, 33.1843, 45.9, 32.0882);
      ctx.bezierCurveTo(45.9, 30.9922, 45.5387, 30.0858, 44.8162, 29.3691);
      ctx.bezierCurveTo(44.0938, 28.6525, 43.18, 28.2941, 42.075, 28.2941);
      ctx.lineTo(0, 28.2941);
      ctx.lineTo(0, 23.2353);
      ctx.lineTo(42.075, 23.2353);
      ctx.bezierCurveTo(44.5825, 23.2353, 46.6969, 24.089, 48.4181, 25.7963);
      ctx.bezierCurveTo(50.1394, 27.5037, 51, 29.601, 51, 32.0882);
      ctx.bezierCurveTo(51, 34.5755, 50.1394, 36.6728, 48.4181, 38.3801);
      ctx.bezierCurveTo(46.6969, 40.0875, 44.5825, 40.9412, 42.075, 40.9412);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  TEMPERATURE_UP: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = secondaryColor;
      ctx.save();
      ctx.font = "10px sans-serif";

      ctx.beginPath();
      ctx.moveTo(16, 6);
      ctx.lineTo(9, 6);
      ctx.lineTo(9, 26);
      ctx.lineTo(5, 26);
      ctx.lineTo(5, 36);
      ctx.lineTo(20, 36);
      ctx.lineTo(20, 26);
      ctx.lineTo(16, 26);
      ctx.lineTo(16, 6);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(12.5, 47);
      ctx.bezierCurveTo(9.04167, 47, 6.09375, 45.7812, 3.65625, 43.3438);
      ctx.bezierCurveTo(1.21875, 40.9062, 0, 37.9583, 0, 34.5);
      ctx.bezierCurveTo(0, 32.5, 0.4375, 30.6354, 1.3125, 28.9062);
      ctx.bezierCurveTo(2.1875, 27.1771, 3.41667, 25.7083, 5, 24.5);
      ctx.lineTo(5, 9.5);
      ctx.bezierCurveTo(5, 7.41667, 5.72917, 5.64583, 7.1875, 4.1875);
      ctx.bezierCurveTo(8.64583, 2.72917, 10.4167, 2, 12.5, 2);
      ctx.bezierCurveTo(14.5833, 2, 16.3542, 2.72917, 17.8125, 4.1875);
      ctx.bezierCurveTo(19.2708, 5.64583, 20, 7.41667, 20, 9.5);
      ctx.lineTo(20, 24.5);
      ctx.bezierCurveTo(21.5833, 25.7083, 22.8125, 27.1771, 23.6875, 28.9062);
      ctx.bezierCurveTo(24.5625, 30.6354, 25, 32.5, 25, 34.5);
      ctx.bezierCurveTo(25, 37.9583, 23.7812, 40.9062, 21.3438, 43.3438);
      ctx.bezierCurveTo(18.9062, 45.7812, 15.9583, 47, 12.5, 47);
      ctx.closePath();
      ctx.moveTo(5, 34.5);
      ctx.lineTo(20, 34.5);
      ctx.bezierCurveTo(20, 33.2917, 19.7396, 32.1667, 19.2188, 31.125);
      ctx.bezierCurveTo(18.6979, 30.0833, 17.9583, 29.2083, 17, 28.5);
      ctx.lineTo(15, 27);
      ctx.lineTo(15, 9.5);
      ctx.bezierCurveTo(15, 8.79167, 14.7604, 8.19792, 14.2812, 7.71875);
      ctx.bezierCurveTo(13.8021, 7.23958, 13.2083, 7, 12.5, 7);
      ctx.bezierCurveTo(11.7917, 7, 11.1979, 7.23958, 10.7188, 7.71875);
      ctx.bezierCurveTo(10.2396, 8.19792, 10, 8.79167, 10, 9.5);
      ctx.lineTo(10, 27);
      ctx.lineTo(8, 28.5);
      ctx.bezierCurveTo(7.04167, 29.2083, 6.30208, 30.0833, 5.78125, 31.125);
      ctx.bezierCurveTo(5.26042, 32.1667, 5, 33.2917, 5, 34.5);
      ctx.closePath();
      ctx.moveTo(38.75, 44.5);
      ctx.lineTo(38.75, 14);
      ctx.lineTo(36, 16.75);
      ctx.lineTo(32.5, 13.25);
      ctx.lineTo(41.25, 4.5);
      ctx.lineTo(50, 13.25);
      ctx.lineTo(46.4375, 16.75);
      ctx.lineTo(43.75, 14.0625);
      ctx.lineTo(43.75, 44.5);
      ctx.lineTo(38.75, 44.5);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  TEMPERATURE_DOWN: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = secondaryColor;
      ctx.save();
      ctx.font = "10px sans-serif";

      ctx.beginPath();
      ctx.moveTo(16, 6);
      ctx.lineTo(9, 6);
      ctx.lineTo(9, 26);
      ctx.lineTo(5, 26);
      ctx.lineTo(5, 36);
      ctx.lineTo(20, 36);
      ctx.lineTo(20, 26);
      ctx.lineTo(16, 26);
      ctx.lineTo(16, 6);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(12.5, 47);
      ctx.bezierCurveTo(9.04167, 47, 6.09375, 45.7812, 3.65625, 43.3438);
      ctx.bezierCurveTo(1.21875, 40.9062, 0, 37.9583, 0, 34.5);
      ctx.bezierCurveTo(0, 32.5, 0.4375, 30.6354, 1.3125, 28.9062);
      ctx.bezierCurveTo(2.1875, 27.1771, 3.41667, 25.7083, 5, 24.5);
      ctx.lineTo(5, 9.5);
      ctx.bezierCurveTo(5, 7.41667, 5.72917, 5.64583, 7.1875, 4.1875);
      ctx.bezierCurveTo(8.64583, 2.72917, 10.4167, 2, 12.5, 2);
      ctx.bezierCurveTo(14.5833, 2, 16.3542, 2.72917, 17.8125, 4.1875);
      ctx.bezierCurveTo(19.2708, 5.64583, 20, 7.41667, 20, 9.5);
      ctx.lineTo(20, 24.5);
      ctx.bezierCurveTo(21.5833, 25.7083, 22.8125, 27.1771, 23.6875, 28.9062);
      ctx.bezierCurveTo(24.5625, 30.6354, 25, 32.5, 25, 34.5);
      ctx.bezierCurveTo(25, 37.9583, 23.7812, 40.9062, 21.3438, 43.3438);
      ctx.bezierCurveTo(18.9062, 45.7812, 15.9583, 47, 12.5, 47);
      ctx.closePath();
      ctx.moveTo(5, 34.5);
      ctx.lineTo(20, 34.5);
      ctx.bezierCurveTo(20, 33.2917, 19.7396, 32.1667, 19.2188, 31.125);
      ctx.bezierCurveTo(18.6979, 30.0833, 17.9583, 29.2083, 17, 28.5);
      ctx.lineTo(15, 27);
      ctx.lineTo(15, 9.5);
      ctx.bezierCurveTo(15, 8.79167, 14.7604, 8.19792, 14.2812, 7.71875);
      ctx.bezierCurveTo(13.8021, 7.23958, 13.2083, 7, 12.5, 7);
      ctx.bezierCurveTo(11.7917, 7, 11.1979, 7.23958, 10.7188, 7.71875);
      ctx.bezierCurveTo(10.2396, 8.19792, 10, 8.79167, 10, 9.5);
      ctx.lineTo(10, 27);
      ctx.lineTo(8, 28.5);
      ctx.bezierCurveTo(7.04167, 29.2083, 6.30208, 30.0833, 5.78125, 31.125);
      ctx.bezierCurveTo(5.26042, 32.1667, 5, 33.2917, 5, 34.5);
      ctx.closePath();
      ctx.moveTo(41.25, 44.5);
      ctx.lineTo(32.5, 35.75);
      ctx.lineTo(36.0625, 32.25);
      ctx.lineTo(38.75, 34.9375);
      ctx.lineTo(38.75, 4.5);
      ctx.lineTo(43.75, 4.5);
      ctx.lineTo(43.75, 35);
      ctx.lineTo(46.5, 32.25);
      ctx.lineTo(50, 35.75);
      ctx.lineTo(41.25, 44.5);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  SKULL: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = secondaryColor;
      ctx.save();
      ctx.font = "10px sans-serif";

      ctx.beginPath();
      ctx.moveTo(43.0567, 36);
      ctx.bezierCurveTo(45.5423, 32.4954, 47, 28.2333, 47, 23.6364);
      ctx.bezierCurveTo(47, 11.6869, 37.1503, 2, 25, 2);
      ctx.bezierCurveTo(12.8497, 2, 3, 11.6869, 3, 23.6364);
      ctx.bezierCurveTo(3, 28.2333, 4.4577, 32.4954, 6.94331, 36);
      ctx.lineTo(43.0567, 36);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = secondaryColor;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(10, 33);
      ctx.lineTo(40, 33);
      ctx.lineTo(40, 45);
      ctx.lineTo(10, 45);
      ctx.lineTo(10, 33);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(25, 5.44444);
      ctx.bezierCurveTo(14.0903, 5.44444, 5.55556, 13.5297, 5.55556, 23.1389);
      ctx.bezierCurveTo(5.55556, 27.5743, 7.34748, 31.6446, 10.3555, 34.7748);
      ctx.bezierCurveTo(10.8408, 35.2798, 11.1111, 35.9474, 11.1111, 36.6411);
      ctx.lineTo(11.1111, 43.5556);
      ctx.lineTo(38.8889, 43.5556);
      ctx.lineTo(38.8889, 36.6411);
      ctx.bezierCurveTo(38.8889, 35.9477, 39.1589, 35.2805, 39.6438, 34.7755);
      ctx.bezierCurveTo(42.6528, 31.642, 44.4444, 27.5712, 44.4444, 23.1389);
      ctx.bezierCurveTo(44.4444, 13.5297, 35.9097, 5.44444, 25, 5.44444);
      ctx.closePath();
      ctx.moveTo(0, 23.1389);
      ctx.bezierCurveTo(0, 10.1971, 11.3653, 0, 25, 0);
      ctx.bezierCurveTo(38.6347, 0, 50, 10.1971, 50, 23.1389);
      ctx.bezierCurveTo(50, 28.6653, 47.9044, 33.7236, 44.4444, 37.6828);
      ctx.lineTo(44.4444, 43.5556);
      ctx.bezierCurveTo(44.4444, 44.9995, 43.8591, 46.3843, 42.8173, 47.4054);
      ctx.bezierCurveTo(41.7754, 48.4264, 40.3623, 49, 38.8889, 49);
      ctx.lineTo(11.1111, 49);
      ctx.bezierCurveTo(9.63769, 49, 8.22461, 48.4264, 7.18274, 47.4054);
      ctx.bezierCurveTo(6.14087, 46.3843, 5.55556, 44.9995, 5.55556, 43.5556);
      ctx.lineTo(5.55556, 37.6833);
      ctx.bezierCurveTo(2.0952, 33.7258, 0, 28.6672, 0, 23.1389);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(19.4444, 35.3889);
      ctx.bezierCurveTo(20.9786, 35.3889, 22.2222, 36.6077, 22.2222, 38.1111);
      ctx.lineTo(22.2222, 46.2778);
      ctx.bezierCurveTo(22.2222, 47.7812, 20.9786, 49, 19.4444, 49);
      ctx.bezierCurveTo(17.9103, 49, 16.6667, 47.7812, 16.6667, 46.2778);
      ctx.lineTo(16.6667, 38.1111);
      ctx.bezierCurveTo(16.6667, 36.6077, 17.9103, 35.3889, 19.4444, 35.3889);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(30.5556, 35.3889);
      ctx.bezierCurveTo(32.0897, 35.3889, 33.3333, 36.6077, 33.3333, 38.1111);
      ctx.lineTo(33.3333, 46.2778);
      ctx.bezierCurveTo(33.3333, 47.7812, 32.0897, 49, 30.5556, 49);
      ctx.bezierCurveTo(29.0214, 49, 27.7778, 47.7812, 27.7778, 46.2778);
      ctx.lineTo(27.7778, 38.1111);
      ctx.bezierCurveTo(27.7778, 36.6077, 29.0214, 35.3889, 30.5556, 35.3889);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(12.7383, 17.928);
      ctx.bezierCurveTo(13.7802, 16.9069, 15.1932, 16.3333, 16.6667, 16.3333);
      ctx.bezierCurveTo(18.1401, 16.3333, 19.5532, 16.9069, 20.595, 17.928);
      ctx.bezierCurveTo(21.6369, 18.949, 22.2222, 20.3338, 22.2222, 21.7778);
      ctx.bezierCurveTo(22.2222, 23.2217, 21.6369, 24.6066, 20.595, 25.6276);
      ctx.bezierCurveTo(19.5532, 26.6486, 18.1401, 27.2222, 16.6667, 27.2222);
      ctx.bezierCurveTo(15.1932, 27.2222, 13.7802, 26.6486, 12.7383, 25.6276);
      ctx.bezierCurveTo(11.6964, 24.6066, 11.1111, 23.2217, 11.1111, 21.7778);
      ctx.bezierCurveTo(11.1111, 20.3338, 11.6964, 18.949, 12.7383, 17.928);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(29.405, 17.928);
      ctx.bezierCurveTo(30.4468, 16.9069, 31.8599, 16.3333, 33.3333, 16.3333);
      ctx.bezierCurveTo(34.8068, 16.3333, 36.2198, 16.9069, 37.2617, 17.928);
      ctx.bezierCurveTo(38.3036, 18.949, 38.8889, 20.3338, 38.8889, 21.7778);
      ctx.bezierCurveTo(38.8889, 23.2217, 38.3036, 24.6066, 37.2617, 25.6276);
      ctx.bezierCurveTo(36.2198, 26.6486, 34.8068, 27.2222, 33.3333, 27.2222);
      ctx.bezierCurveTo(31.8599, 27.2222, 30.4468, 26.6486, 29.405, 25.6276);
      ctx.bezierCurveTo(28.3631, 24.6066, 27.7778, 23.2217, 27.7778, 21.7778);
      ctx.bezierCurveTo(27.7778, 20.3338, 28.3631, 18.949, 29.405, 17.928);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  WINE: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = secondaryColor;
      ctx.save();
      ctx.font = "10px sans-serif";

      ctx.beginPath();
      ctx.moveTo(12, 17);
      ctx.lineTo(37, 23.5);
      ctx.lineTo(30.5, 32);
      ctx.lineTo(12, 27.5);
      ctx.lineTo(12, 17);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(12.8572, 46.55);
      ctx.bezierCurveTo(12.8572, 45.1969, 13.9445, 44.1, 15.2858, 44.1);
      ctx.lineTo(34.7142, 44.1);
      ctx.bezierCurveTo(36.0555, 44.1, 37.1428, 45.1969, 37.1428, 46.55);
      ctx.bezierCurveTo(37.1428, 47.9031, 36.0555, 49, 34.7142, 49);
      ctx.lineTo(15.2858, 49);
      ctx.bezierCurveTo(13.9445, 49, 12.8572, 47.9031, 12.8572, 46.55);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(25, 29.4);
      ctx.bezierCurveTo(26.3413, 29.4, 27.4286, 30.4969, 27.4286, 31.85);
      ctx.lineTo(27.4286, 46.55);
      ctx.bezierCurveTo(27.4286, 47.9031, 26.3413, 49, 25, 49);
      ctx.bezierCurveTo(23.6587, 49, 22.5714, 47.9031, 22.5714, 46.55);
      ctx.lineTo(22.5714, 31.85);
      ctx.bezierCurveTo(22.5714, 30.4969, 23.6587, 29.4, 25, 29.4);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(10.4531, 2.10352);
      ctx.bezierCurveTo(10.624, 0.896528, 11.6487, 0, 12.8572, 0);
      ctx.lineTo(37.1428, 0);
      ctx.bezierCurveTo(38.3513, 0, 39.376, 0.896528, 39.5469, 2.10352);
      ctx.lineTo(41.9754, 19.2535);
      ctx.bezierCurveTo(41.9917, 19.3683, 41.9999, 19.4841, 41.9999, 19.6);
      ctx.bezierCurveTo(41.9999, 28.8032, 33.8696, 34.3, 25, 34.3);
      ctx.bezierCurveTo(16.1304, 34.3, 8.00014, 28.8032, 8.00014, 19.6);
      ctx.bezierCurveTo(8.00014, 19.4841, 8.0083, 19.3683, 8.02455, 19.2535);
      ctx.lineTo(10.4531, 2.10352);
      ctx.closePath();
      ctx.moveTo(14.9635, 4.9);
      ctx.lineTo(12.8587, 19.764);
      ctx.bezierCurveTo(12.9544, 25.2389, 17.8445, 29.4, 25, 29.4);
      ctx.bezierCurveTo(32.1555, 29.4, 37.0456, 25.2389, 37.1413, 19.764);
      ctx.lineTo(35.0365, 4.9);
      ctx.lineTo(14.9635, 4.9);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(17.7143, 19.6);
      ctx.bezierCurveTo(15.6125, 19.6, 13.5673, 20.2877, 11.8858, 21.56);
      ctx.bezierCurveTo(10.8128, 22.3719, 9.2906, 22.1525, 8.48585, 21.07);
      ctx.bezierCurveTo(7.6811, 19.9875, 7.89856, 18.4519, 8.97156, 17.64);
      ctx.bezierCurveTo(11.4938, 15.7316, 14.5615, 14.7, 17.7143, 14.7);
      ctx.bezierCurveTo(20.8671, 14.7, 23.9349, 15.7316, 26.4571, 17.64);
      ctx.bezierCurveTo(28.1386, 18.9123, 30.1838, 19.6, 32.2857, 19.6);
      ctx.bezierCurveTo(34.3875, 19.6, 36.4327, 18.9123, 38.1142, 17.64);
      ctx.bezierCurveTo(39.1872, 16.8281, 40.7094, 17.0475, 41.5141, 18.13);
      ctx.bezierCurveTo(42.3189, 19.2125, 42.1014, 20.7481, 41.0284, 21.56);
      ctx.bezierCurveTo(38.5062, 23.4684, 35.4385, 24.5, 32.2857, 24.5);
      ctx.bezierCurveTo(29.1329, 24.5, 26.0651, 23.4684, 23.5429, 21.56);
      ctx.bezierCurveTo(21.8614, 20.2877, 19.8162, 19.6, 17.7143, 19.6);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  PINT: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = secondaryColor;
      ctx.save();
      ctx.font = "10px sans-serif";

      ctx.beginPath();
      ctx.moveTo(10.5, 16.5);
      ctx.lineTo(38.5, 16.5);
      ctx.lineTo(33.5, 32);
      ctx.lineTo(33.5, 46.5);
      ctx.lineTo(15, 46.5);
      ctx.lineTo(15, 32);
      ctx.lineTo(10.5, 16.5);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(9.42262, 1.43518);
      ctx.bezierCurveTo(10.3335, 0.516249, 11.5689, 0, 12.8571, 0);
      ctx.lineTo(37.1429, 0);
      ctx.bezierCurveTo(38.431, 0, 39.6665, 0.516247, 40.5774, 1.43518);
      ctx.bezierCurveTo(41.4883, 2.35411, 42, 3.60044, 42, 4.9);
      ctx.lineTo(42, 14.7);
      ctx.bezierCurveTo(42, 18.5573, 41.1842, 21.3583, 39.7392, 24.636);
      ctx.bezierCurveTo(39.7389, 24.6367, 39.7395, 24.6353, 39.7392, 24.636);
      ctx.lineTo(38.987, 26.3496);
      ctx.bezierCurveTo(37.7794, 29.0934, 37.1429, 32.1323, 37.1429, 35.2188);
      ctx.lineTo(37.1429, 44.1);
      ctx.bezierCurveTo(37.1429, 45.3996, 36.6311, 46.6459, 35.7202, 47.5648);
      ctx.bezierCurveTo(34.8093, 48.4838, 33.5739, 49, 32.2857, 49);
      ctx.lineTo(17.7143, 49);
      ctx.bezierCurveTo(16.4261, 49, 15.1907, 48.4838, 14.2798, 47.5648);
      ctx.bezierCurveTo(13.3689, 46.6459, 12.8571, 45.3996, 12.8571, 44.1);
      ctx.lineTo(12.8571, 35.2147);
      ctx.bezierCurveTo(12.8621, 32.1617, 12.2337, 29.1415, 11.0124, 26.3481);
      ctx.bezierCurveTo(11.0121, 26.3476, 11.0126, 26.3487, 11.0124, 26.3481);
      ctx.lineTo(10.2611, 24.6367);
      ctx.bezierCurveTo(10.2609, 24.6362, 10.2613, 24.6372, 10.2611, 24.6367);
      ctx.bezierCurveTo(8.81951, 21.361, 8, 18.5586, 8, 14.7);
      ctx.lineTo(8, 4.9);
      ctx.bezierCurveTo(8, 3.60044, 8.51173, 2.3541, 9.42262, 1.43518);
      ctx.closePath();
      ctx.moveTo(37.1429, 4.9);
      ctx.lineTo(12.8571, 4.9);
      ctx.lineTo(12.8571, 14.7);
      ctx.bezierCurveTo(12.8571, 17.6861, 13.4466, 19.7996, 14.7003, 22.6483);
      ctx.lineTo(15.4555, 24.3685);
      ctx.bezierCurveTo(16.9507, 27.7873, 17.7201, 31.4839, 17.7143, 35.2206);
      ctx.bezierCurveTo(17.7143, 35.2213, 17.7143, 35.2199, 17.7143, 35.2206);
      ctx.lineTo(17.7143, 44.1);
      ctx.lineTo(32.2857, 44.1);
      ctx.lineTo(32.2857, 35.2188);
      ctx.bezierCurveTo(32.2857, 31.4601, 33.0586, 27.7448, 34.5466, 24.3638);
      ctx.lineTo(35.3003, 22.6468);
      ctx.bezierCurveTo(36.5553, 19.8005, 37.1429, 17.6871, 37.1429, 14.7);
      ctx.lineTo(37.1429, 4.9);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(8, 14.7);
      ctx.bezierCurveTo(8, 13.3469, 9.08731, 12.25, 10.4286, 12.25);
      ctx.lineTo(39.5714, 12.25);
      ctx.bezierCurveTo(40.9127, 12.25, 42, 13.3469, 42, 14.7);
      ctx.bezierCurveTo(42, 16.0531, 40.9127, 17.15, 39.5714, 17.15);
      ctx.lineTo(10.4286, 17.15);
      ctx.bezierCurveTo(9.08731, 17.15, 8, 16.0531, 8, 14.7);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  PIN_TWO: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = secondaryColor;
      ctx.save();
      ctx.font = "10px sans-serif";

      ctx.beginPath();
      ctx.moveTo(23, 46.5);
      ctx.bezierCurveTo(31.5, 41, 42, 32.4934, 42, 22);
      ctx.bezierCurveTo(42, 11.5066, 33.4934, 3, 23, 3);
      ctx.bezierCurveTo(12.5066, 3, 4, 11.5066, 4, 22);
      ctx.bezierCurveTo(4, 32.4934, 15.5, 41, 23, 46.5);
      ctx.closePath();
      ctx.moveTo(23, 28);
      ctx.bezierCurveTo(26.3137, 28, 29, 25.3137, 29, 22);
      ctx.bezierCurveTo(29, 18.6863, 26.3137, 16, 23, 16);
      ctx.bezierCurveTo(19.6863, 16, 17, 18.6863, 17, 22);
      ctx.bezierCurveTo(17, 25.3137, 19.6863, 28, 23, 28);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(17.0861, 15.0631);
      ctx.bezierCurveTo(18.9198, 13.2321, 21.4068, 12.2035, 24, 12.2035);
      ctx.bezierCurveTo(26.5932, 12.2035, 29.0802, 13.2321, 30.9139, 15.0631);
      ctx.bezierCurveTo(32.7476, 16.8941, 33.7778, 19.3774, 33.7778, 21.9668);
      ctx.bezierCurveTo(33.7778, 24.5562, 32.7476, 27.0396, 30.9139, 28.8705);
      ctx.bezierCurveTo(29.0802, 30.7015, 26.5932, 31.7302, 24, 31.7302);
      ctx.bezierCurveTo(21.4068, 31.7302, 18.9198, 30.7015, 17.0861, 28.8705);
      ctx.bezierCurveTo(15.2524, 27.0396, 14.2222, 24.5562, 14.2222, 21.9668);
      ctx.bezierCurveTo(14.2222, 19.3774, 15.2524, 16.8941, 17.0861, 15.0631);
      ctx.closePath();
      ctx.moveTo(24, 17.0851);
      ctx.bezierCurveTo(22.7034, 17.0851, 21.4599, 17.5995, 20.543, 18.515);
      ctx.bezierCurveTo(19.6262, 19.4304, 19.1111, 20.6721, 19.1111, 21.9668);
      ctx.bezierCurveTo(19.1111, 23.2615, 19.6262, 24.5032, 20.543, 25.4187);
      ctx.bezierCurveTo(21.4599, 26.3342, 22.7034, 26.8485, 24, 26.8485);
      ctx.bezierCurveTo(25.2966, 26.8485, 26.5401, 26.3342, 27.457, 25.4187);
      ctx.bezierCurveTo(28.3738, 24.5032, 28.8889, 23.2615, 28.8889, 21.9668);
      ctx.bezierCurveTo(28.8889, 20.6721, 28.3738, 19.4304, 27.457, 18.515);
      ctx.bezierCurveTo(26.5401, 17.5995, 25.2966, 17.0851, 24, 17.0851);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(24, 4.88167);
      ctx.bezierCurveTo(20.6158, 4.88167, 17.3076, 5.88372, 14.4937, 7.7611);
      ctx.bezierCurveTo(11.6798, 9.63848, 9.48661, 12.3069, 8.19149, 15.4289);
      ctx.bezierCurveTo(6.89636, 18.5508, 6.55745, 21.9862, 7.21762, 25.3005);
      ctx.bezierCurveTo(7.87776, 28.6147, 9.50726, 31.659, 11.9001, 34.0485);
      ctx.lineTo(22.2736, 44.4043);
      ctx.bezierCurveTo(22.732, 44.8615, 23.3533, 45.1183, 24.0012, 45.1183);
      ctx.bezierCurveTo(24.6491, 45.1183, 25.2705, 44.8615, 25.7288, 44.4043);
      ctx.lineTo(36.0997, 34.0487);
      ctx.bezierCurveTo(38.4926, 31.6592, 40.1222, 28.6148, 40.7824, 25.3005);
      ctx.bezierCurveTo(41.4425, 21.9862, 41.1036, 18.5508, 39.8085, 15.4289);
      ctx.bezierCurveTo(38.5134, 12.3069, 36.3202, 9.63848, 33.5063, 7.7611);
      ctx.bezierCurveTo(30.6924, 5.88372, 27.3842, 4.88167, 24, 4.88167);
      ctx.closePath();
      ctx.moveTo(11.7776, 3.70212);
      ctx.bezierCurveTo(15.3954, 1.28834, 19.6489, 0, 24, 0);
      ctx.bezierCurveTo(28.3511, 0, 32.6046, 1.28834, 36.2224, 3.70212);
      ctx.bezierCurveTo(39.8403, 6.11589, 42.6601, 9.54668, 44.3252, 13.5607);
      ctx.bezierCurveTo(45.9904, 17.5746, 46.4261, 21.9915, 45.5774, 26.2528);
      ctx.bezierCurveTo(44.7286, 30.514, 42.6334, 34.4283, 39.5567, 37.5005);
      ctx.lineTo(29.1849, 47.857);
      ctx.bezierCurveTo(27.8099, 49.2287, 25.9449, 50, 24.0012, 50);
      ctx.bezierCurveTo(22.0576, 50, 20.1934, 49.2295, 18.8184, 47.8579);
      ctx.lineTo(8.44351, 37.5008);
      ctx.bezierCurveTo(5.36687, 34.4285, 3.27143, 30.514, 2.42265, 26.2528);
      ctx.bezierCurveTo(1.57387, 21.9915, 2.00961, 17.5746, 3.67477, 13.5607);
      ctx.bezierCurveTo(5.33993, 9.54668, 8.15972, 6.11589, 11.7776, 3.70212);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  HOME: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = secondaryColor;
      ctx.save();
      ctx.font = "10px sans-serif";

      ctx.beginPath();
      ctx.moveTo(7, 20.1217);
      ctx.lineTo(25, 4);
      ctx.lineTo(43, 20.1217);
      ctx.lineTo(43, 46);
      ctx.lineTo(7, 46);
      ctx.lineTo(7, 20.1217);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(23.2322, 0.732233);
      ctx.bezierCurveTo(
        24.2085,
        -0.244078,
        25.7915,
        -0.244078,
        26.7678,
        0.732233
      );
      ctx.lineTo(49.2677, 23.2322);
      ctx.bezierCurveTo(49.9827, 23.9472, 50.1966, 25.0225, 49.8096, 25.9567);
      ctx.bezierCurveTo(49.4227, 26.8909, 48.5111, 27.5, 47.4999, 27.5);
      ctx.lineTo(42.5, 27.5);
      ctx.bezierCurveTo(41.1192, 27.5, 40, 26.3807, 40, 25);
      ctx.bezierCurveTo(40, 23.928, 40.6747, 23.0136, 41.6227, 22.6583);
      ctx.lineTo(25, 6.03553);
      ctx.lineTo(8.37733, 22.6583);
      ctx.bezierCurveTo(9.32529, 23.0136, 10, 23.928, 10, 25);
      ctx.bezierCurveTo(10, 26.3807, 8.88076, 27.5, 7.50005, 27.5);
      ctx.lineTo(2.50007, 27.5);
      ctx.bezierCurveTo(1.48891, 27.5, 0.577325, 26.8909, 0.190374, 25.9567);
      ctx.bezierCurveTo(
        -0.196578,
        25.0225,
        0.0173111,
        23.9472,
        0.732304,
        23.2322
      );
      ctx.lineTo(23.2322, 0.732233);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(7.50005, 22.5);
      ctx.bezierCurveTo(8.88076, 22.5, 10, 23.6193, 10, 25);
      ctx.lineTo(10, 42.5);
      ctx.bezierCurveTo(10, 43.163, 10.2634, 43.7989, 10.7323, 44.2678);
      ctx.bezierCurveTo(11.2011, 44.7366, 11.837, 45, 12.5, 45);
      ctx.lineTo(37.5, 45);
      ctx.bezierCurveTo(38.163, 45, 38.7989, 44.7366, 39.2677, 44.2678);
      ctx.bezierCurveTo(39.7366, 43.7989, 40, 43.163, 40, 42.5);
      ctx.lineTo(40, 25);
      ctx.bezierCurveTo(40, 23.6193, 41.1192, 22.5, 42.5, 22.5);
      ctx.bezierCurveTo(43.8807, 22.5, 44.9999, 23.6193, 44.9999, 25);
      ctx.lineTo(44.9999, 42.5);
      ctx.bezierCurveTo(44.9999, 44.4891, 44.2098, 46.3968, 42.8032, 47.8033);
      ctx.bezierCurveTo(41.3967, 49.2098, 39.4891, 50, 37.5, 50);
      ctx.lineTo(12.5, 50);
      ctx.bezierCurveTo(10.5109, 50, 8.60327, 49.2098, 7.19675, 47.8033);
      ctx.bezierCurveTo(5.79023, 46.3968, 5.00006, 44.4891, 5.00006, 42.5);
      ctx.lineTo(5.00006, 25);
      ctx.bezierCurveTo(5.00006, 23.6193, 6.11934, 22.5, 7.50005, 22.5);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(22.5, 30);
      ctx.bezierCurveTo(21.837, 30, 21.2011, 30.2634, 20.7322, 30.7322);
      ctx.bezierCurveTo(20.2634, 31.2011, 20, 31.837, 20, 32.5);
      ctx.lineTo(20, 47.5);
      ctx.bezierCurveTo(20, 48.8807, 18.8807, 50, 17.5, 50);
      ctx.bezierCurveTo(16.1193, 50, 15, 48.8807, 15, 47.5);
      ctx.lineTo(15, 32.5);
      ctx.bezierCurveTo(15, 30.5109, 15.7902, 28.6032, 17.1967, 27.1967);
      ctx.bezierCurveTo(18.6032, 25.7902, 20.5109, 25, 22.5, 25);
      ctx.lineTo(27.5, 25);
      ctx.bezierCurveTo(29.4891, 25, 31.3968, 25.7902, 32.8033, 27.1967);
      ctx.bezierCurveTo(34.2098, 28.6032, 35, 30.5109, 35, 32.5);
      ctx.lineTo(35, 47.5);
      ctx.bezierCurveTo(35, 48.8807, 33.8807, 50, 32.5, 50);
      ctx.bezierCurveTo(31.1193, 50, 30, 48.8807, 30, 47.5);
      ctx.lineTo(30, 32.5);
      ctx.bezierCurveTo(30, 31.837, 29.7366, 31.2011, 29.2678, 30.7322);
      ctx.bezierCurveTo(28.7989, 30.2634, 28.163, 30, 27.5, 30);
      ctx.lineTo(22.5, 30);
      ctx.closePath();
      ctx.fill("evenodd");
      ctx.stroke();
      ctx.restore();
      ctx.restore();
    },
  },
  DOT: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = secondaryColor;

      ctx.miterLimit = 4;
      ctx.fillStyle = secondaryColor;
      ctx.save();
      ctx.font = "10px sans-serif";

      ctx.beginPath();
      ctx.arc(25, 25, 16, 0, 6.283185307179586, false);
      ctx.closePath();
      ctx.fill();
      ctx.restore();
      ctx.save();
      ctx.fillStyle = color;
      ctx.font = "   10px sans-serif";
      ctx.beginPath();
      ctx.moveTo(36, 25);
      ctx.bezierCurveTo(36, 18.9249, 31.0751, 14, 25, 14);
      ctx.bezierCurveTo(18.9249, 14, 14, 18.9249, 14, 25);
      ctx.bezierCurveTo(14, 31.0751, 18.9249, 36, 25, 36);
      ctx.lineTo(25, 41);
      ctx.bezierCurveTo(16.1634, 41, 9, 33.8366, 9, 25);
      ctx.bezierCurveTo(9, 16.1634, 16.1634, 9, 25, 9);
      ctx.bezierCurveTo(33.8366, 9, 41, 16.1634, 41, 25);
      ctx.bezierCurveTo(41, 33.8366, 33.8366, 41, 25, 41);
      ctx.lineTo(25, 36);
      ctx.bezierCurveTo(31.0751, 36, 36, 31.0751, 36, 25);
      ctx.closePath();
      ctx.fill();

      ctx.restore();
      ctx.restore();

      // PASTE FROM ctx.beginPath(); to ctx.restore();
    },
  },

  PLACEHOLDER: {
    draw: function (config: PointDrawingConfig) {
      const ctx = config.ctx;
      const color = config.color;
      const secondaryColor = config.secondaryColor ?? "rgba(0,0,0,0)";
      const scale = config.scale;
      const offsetX = config.offsetX ?? 0;
      const offsetY = config.offsetY ?? 0;

      ctx.save();
      ctx.translate(offsetX, offsetY);

      ctx.scale(scale, scale);
      ctx.strokeStyle = "rgba(0,0,0,0)";

      ctx.miterLimit = 4;
      ctx.fillStyle = color;
      ctx.save();
      ctx.font = "10px sans-serif";

      // PASTE FROM ctx.beginPath(); to ctx.restore();
    },
  },
};
